var Jt = (i) => {
  throw TypeError(i);
};
var He = (i, s, p) => s.has(i) || Jt("Cannot " + p);
var T = (i, s, p) => (He(i, s, "read from private field"), p ? p.call(i) : s.get(i)), oe = (i, s, p) => s.has(i) ? Jt("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(i) : s.set(i, p), $ = (i, s, p, v) => (He(i, s, "write to private field"), v ? v.call(i, p) : s.set(i, p), p), ie = (i, s, p) => (He(i, s, "access private method"), p);
import { c as Wr } from "./clsx-OuTLNxxd.mjs.js";
import { j as X } from "./client-zRtiouUI.mjs.js";
import { c as Mr, b as ze } from "./button-CaEAZQGx.mjs.js";
import { r as se, c as Gt, g as Xr } from "./index-IEz1e_US.mjs.js";
import { S as Yr, p as Ht, r as pe, s as At, a as je, n as Ot, i as Tt, b as Wt, t as Zr, c as Qe, f as $r, d as ei, e as Xt, g as zr, h as ti, u as ri, k as zt } from "./layout-Do4l8J3p.mjs.js";
var le, z, Pe, ce, Se, Ce, be, me, Be, Ae, Oe, qe, Re, ke, Te, J, Le, It, Ut, Nt, Dt, Lt, jt, Pt, Qr, Fr, ii = (Fr = class extends Yr {
  constructor(s, p) {
    super();
    oe(this, J);
    oe(this, le);
    oe(this, z);
    oe(this, Pe);
    oe(this, ce);
    oe(this, Se);
    oe(this, Ce);
    oe(this, be);
    oe(this, me);
    oe(this, Be);
    oe(this, Ae);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    oe(this, Oe);
    oe(this, qe);
    oe(this, Re);
    oe(this, ke);
    oe(this, Te, /* @__PURE__ */ new Set());
    this.options = p, $(this, le, s), $(this, me, null), $(this, be, Ht()), this.bindMethods(), this.setOptions(p);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (T(this, z).addObserver(this), Yt(T(this, z), this.options) ? ie(this, J, Le).call(this) : this.updateResult(), ie(this, J, Dt).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return Bt(
      T(this, z),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return Bt(
      T(this, z),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), ie(this, J, Lt).call(this), ie(this, J, jt).call(this), T(this, z).removeObserver(this);
  }
  setOptions(s) {
    const p = this.options, v = T(this, z);
    if (this.options = T(this, le).defaultQueryOptions(s), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof pe(this.options.enabled, T(this, z)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    ie(this, J, Pt).call(this), T(this, z).setOptions(this.options), p._defaulted && !At(this.options, p) && T(this, le).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: T(this, z),
      observer: this
    });
    const _ = this.hasListeners();
    _ && Zt(
      T(this, z),
      v,
      this.options,
      p
    ) && ie(this, J, Le).call(this), this.updateResult(), _ && (T(this, z) !== v || pe(this.options.enabled, T(this, z)) !== pe(p.enabled, T(this, z)) || je(this.options.staleTime, T(this, z)) !== je(p.staleTime, T(this, z))) && ie(this, J, It).call(this);
    const d = ie(this, J, Ut).call(this);
    _ && (T(this, z) !== v || pe(this.options.enabled, T(this, z)) !== pe(p.enabled, T(this, z)) || d !== T(this, ke)) && ie(this, J, Nt).call(this, d);
  }
  getOptimisticResult(s) {
    const p = T(this, le).getQueryCache().build(T(this, le), s), v = this.createResult(p, s);
    return oi(this, v) && ($(this, ce, v), $(this, Ce, this.options), $(this, Se, T(this, z).state)), v;
  }
  getCurrentResult() {
    return T(this, ce);
  }
  trackResult(s, p) {
    return new Proxy(s, {
      get: (v, _) => (this.trackProp(_), p?.(_), _ === "promise" && !this.options.experimental_prefetchInRender && T(this, be).status === "pending" && T(this, be).reject(
        new Error(
          "experimental_prefetchInRender feature flag is not enabled"
        )
      ), Reflect.get(v, _))
    });
  }
  trackProp(s) {
    T(this, Te).add(s);
  }
  getCurrentQuery() {
    return T(this, z);
  }
  refetch({ ...s } = {}) {
    return this.fetch({
      ...s
    });
  }
  fetchOptimistic(s) {
    const p = T(this, le).defaultQueryOptions(s), v = T(this, le).getQueryCache().build(T(this, le), p);
    return v.fetch().then(() => this.createResult(v, p));
  }
  fetch(s) {
    return ie(this, J, Le).call(this, {
      ...s,
      cancelRefetch: s.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), T(this, ce)));
  }
  createResult(s, p) {
    const v = T(this, z), _ = this.options, d = T(this, ce), u = T(this, Se), g = T(this, Ce), k = s !== v ? s.state : T(this, Pe), { state: E } = s;
    let S = { ...E }, C = !1, x;
    if (p._optimisticResults) {
      const h = this.hasListeners(), c = !h && Yt(s, p), b = h && Zt(s, v, p, _);
      (c || b) && (S = {
        ...S,
        ...ei(E.data, s.options)
      }), p._optimisticResults === "isRestoring" && (S.fetchStatus = "idle");
    }
    let { error: R, errorUpdatedAt: w, status: e } = S;
    x = S.data;
    let t = !1;
    if (p.placeholderData !== void 0 && x === void 0 && e === "pending") {
      let h;
      d?.isPlaceholderData && p.placeholderData === g?.placeholderData ? (h = d.data, t = !0) : h = typeof p.placeholderData == "function" ? p.placeholderData(
        T(this, Oe)?.state.data,
        T(this, Oe)
      ) : p.placeholderData, h !== void 0 && (e = "success", x = Xt(
        d?.data,
        h,
        p
      ), C = !0);
    }
    if (p.select && x !== void 0 && !t)
      if (d && x === u?.data && p.select === T(this, Be))
        x = T(this, Ae);
      else
        try {
          $(this, Be, p.select), x = p.select(x), x = Xt(d?.data, x, p), $(this, Ae, x), $(this, me, null);
        } catch (h) {
          $(this, me, h);
        }
    T(this, me) && (R = T(this, me), x = T(this, Ae), w = Date.now(), e = "error");
    const y = S.fetchStatus === "fetching", n = e === "pending", f = e === "error", q = n && y, l = x !== void 0, r = {
      status: e,
      fetchStatus: S.fetchStatus,
      isPending: n,
      isSuccess: e === "success",
      isError: f,
      isInitialLoading: q,
      isLoading: q,
      data: x,
      dataUpdatedAt: S.dataUpdatedAt,
      error: R,
      errorUpdatedAt: w,
      failureCount: S.fetchFailureCount,
      failureReason: S.fetchFailureReason,
      errorUpdateCount: S.errorUpdateCount,
      isFetched: S.dataUpdateCount > 0 || S.errorUpdateCount > 0,
      isFetchedAfterMount: S.dataUpdateCount > k.dataUpdateCount || S.errorUpdateCount > k.errorUpdateCount,
      isFetching: y,
      isRefetching: y && !n,
      isLoadingError: f && !l,
      isPaused: S.fetchStatus === "paused",
      isPlaceholderData: C,
      isRefetchError: f && l,
      isStale: Qt(s, p),
      refetch: this.refetch,
      promise: T(this, be),
      isEnabled: pe(p.enabled, s) !== !1
    };
    if (this.options.experimental_prefetchInRender) {
      const h = (m) => {
        r.status === "error" ? m.reject(r.error) : r.data !== void 0 && m.resolve(r.data);
      }, c = () => {
        const m = $(this, be, r.promise = Ht());
        h(m);
      }, b = T(this, be);
      switch (b.status) {
        case "pending":
          s.queryHash === v.queryHash && h(b);
          break;
        case "fulfilled":
          (r.status === "error" || r.data !== b.value) && c();
          break;
        case "rejected":
          (r.status !== "error" || r.error !== b.reason) && c();
          break;
      }
    }
    return r;
  }
  updateResult() {
    const s = T(this, ce), p = this.createResult(T(this, z), this.options);
    if ($(this, Se, T(this, z).state), $(this, Ce, this.options), T(this, Se).data !== void 0 && $(this, Oe, T(this, z)), At(p, s))
      return;
    $(this, ce, p);
    const v = () => {
      if (!s)
        return !0;
      const { notifyOnChangeProps: _ } = this.options, d = typeof _ == "function" ? _() : _;
      if (d === "all" || !d && !T(this, Te).size)
        return !0;
      const u = new Set(
        d ?? T(this, Te)
      );
      return this.options.throwOnError && u.add("error"), Object.keys(T(this, ce)).some((g) => {
        const a = g;
        return T(this, ce)[a] !== s[a] && u.has(a);
      });
    };
    ie(this, J, Qr).call(this, { listeners: v() });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && ie(this, J, Dt).call(this);
  }
}, le = new WeakMap(), z = new WeakMap(), Pe = new WeakMap(), ce = new WeakMap(), Se = new WeakMap(), Ce = new WeakMap(), be = new WeakMap(), me = new WeakMap(), Be = new WeakMap(), Ae = new WeakMap(), Oe = new WeakMap(), qe = new WeakMap(), Re = new WeakMap(), ke = new WeakMap(), Te = new WeakMap(), J = new WeakSet(), Le = function(s) {
  ie(this, J, Pt).call(this);
  let p = T(this, z).fetch(
    this.options,
    s
  );
  return s?.throwOnError || (p = p.catch(Ot)), p;
}, It = function() {
  ie(this, J, Lt).call(this);
  const s = je(
    this.options.staleTime,
    T(this, z)
  );
  if (Tt || T(this, ce).isStale || !Wt(s))
    return;
  const v = Zr(T(this, ce).dataUpdatedAt, s) + 1;
  $(this, qe, Qe.setTimeout(() => {
    T(this, ce).isStale || this.updateResult();
  }, v));
}, Ut = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(T(this, z)) : this.options.refetchInterval) ?? !1;
}, Nt = function(s) {
  ie(this, J, jt).call(this), $(this, ke, s), !(Tt || pe(this.options.enabled, T(this, z)) === !1 || !Wt(T(this, ke)) || T(this, ke) === 0) && $(this, Re, Qe.setInterval(() => {
    (this.options.refetchIntervalInBackground || $r.isFocused()) && ie(this, J, Le).call(this);
  }, T(this, ke)));
}, Dt = function() {
  ie(this, J, It).call(this), ie(this, J, Nt).call(this, ie(this, J, Ut).call(this));
}, Lt = function() {
  T(this, qe) && (Qe.clearTimeout(T(this, qe)), $(this, qe, void 0));
}, jt = function() {
  T(this, Re) && (Qe.clearInterval(T(this, Re)), $(this, Re, void 0));
}, Pt = function() {
  const s = T(this, le).getQueryCache().build(T(this, le), this.options);
  if (s === T(this, z))
    return;
  const p = T(this, z);
  $(this, z, s), $(this, Pe, s.state), this.hasListeners() && (p?.removeObserver(this), s.addObserver(this));
}, Qr = function(s) {
  zr.batch(() => {
    s.listeners && this.listeners.forEach((p) => {
      p(T(this, ce));
    }), T(this, le).getQueryCache().notify({
      query: T(this, z),
      type: "observerResultsUpdated"
    });
  });
}, Fr);
function ni(i, s) {
  return pe(s.enabled, i) !== !1 && i.state.data === void 0 && !(i.state.status === "error" && s.retryOnMount === !1);
}
function Yt(i, s) {
  return ni(i, s) || i.state.data !== void 0 && Bt(i, s, s.refetchOnMount);
}
function Bt(i, s, p) {
  if (pe(s.enabled, i) !== !1 && je(s.staleTime, i) !== "static") {
    const v = typeof p == "function" ? p(i) : p;
    return v === "always" || v !== !1 && Qt(i, s);
  }
  return !1;
}
function Zt(i, s, p, v) {
  return (i !== s || pe(v.enabled, i) === !1) && (!p.suspense || i.state.status !== "error") && Qt(i, p);
}
function Qt(i, s) {
  return pe(s.enabled, i) !== !1 && i.isStaleByTime(je(s.staleTime, i));
}
function oi(i, s) {
  return !At(i.getCurrentResult(), s);
}
var Kr = se.createContext(!1), si = () => se.useContext(Kr);
Kr.Provider;
function ai() {
  let i = !1;
  return {
    clearReset: () => {
      i = !1;
    },
    reset: () => {
      i = !0;
    },
    isReset: () => i
  };
}
var ui = se.createContext(ai()), ci = () => se.useContext(ui), li = (i, s) => {
  (i.suspense || i.throwOnError || i.experimental_prefetchInRender) && (s.isReset() || (i.retryOnMount = !1));
}, fi = (i) => {
  se.useEffect(() => {
    i.clearReset();
  }, [i]);
}, di = ({
  result: i,
  errorResetBoundary: s,
  throwOnError: p,
  query: v,
  suspense: _
}) => i.isError && !s.isReset() && !i.isFetching && v && (_ && i.data === void 0 || ti(p, [i.error, v])), vi = (i) => {
  if (i.suspense) {
    const p = (_) => _ === "static" ? _ : Math.max(_ ?? 1e3, 1e3), v = i.staleTime;
    i.staleTime = typeof v == "function" ? (..._) => p(v(..._)) : p(v), typeof i.gcTime == "number" && (i.gcTime = Math.max(
      i.gcTime,
      1e3
    ));
  }
}, hi = (i, s) => i.isLoading && i.isFetching && !s, gi = (i, s) => i?.suspense && s.isPending, $t = (i, s, p) => s.fetchOptimistic(i).catch(() => {
  p.clearReset();
});
function _i(i, s, p) {
  const v = si(), _ = ci(), d = ri(), u = d.defaultQueryOptions(i);
  d.getDefaultOptions().queries?._experimental_beforeQuery?.(
    u
  ), u._optimisticResults = v ? "isRestoring" : "optimistic", vi(u), li(u, _), fi(_);
  const g = !d.getQueryCache().get(u.queryHash), [a] = se.useState(
    () => new s(
      d,
      u
    )
  ), k = a.getOptimisticResult(u), E = !v && i.subscribed !== !1;
  if (se.useSyncExternalStore(
    se.useCallback(
      (S) => {
        const C = E ? a.subscribe(zr.batchCalls(S)) : Ot;
        return a.updateResult(), C;
      },
      [a, E]
    ),
    () => a.getCurrentResult(),
    () => a.getCurrentResult()
  ), se.useEffect(() => {
    a.setOptions(u);
  }, [u, a]), gi(u, k))
    throw $t(u, a, _);
  if (di({
    result: k,
    errorResetBoundary: _,
    throwOnError: u.throwOnError,
    query: d.getQueryCache().get(u.queryHash),
    suspense: u.suspense
  }))
    throw k.error;
  return d.getDefaultOptions().queries?._experimental_afterQuery?.(
    u,
    k
  ), u.experimental_prefetchInRender && !Tt && hi(k, v) && (g ? (
    // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
    $t(u, a, _)
  ) : (
    // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
    d.getQueryCache().get(u.queryHash)?.promise
  ))?.catch(Ot).finally(() => {
    a.updateResult();
  }), u.notifyOnChangeProps ? k : a.trackResult(k);
}
function Kt(i, s) {
  return _i(i, ii);
}
var We = { exports: {} }, er;
function fe() {
  return er || (er = 1, (function(i) {
    function s(p) {
      return p && p.__esModule ? p : {
        default: p
      };
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(We)), We.exports;
}
var Xe = { exports: {} }, tr;
function ge() {
  return tr || (tr = 1, (function(i) {
    function s(p, v) {
      if (!(p instanceof v)) throw new TypeError("Cannot call a class as a function");
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Xe)), Xe.exports;
}
var Ye = { exports: {} }, Ze = { exports: {} }, $e = { exports: {} }, rr;
function Ee() {
  return rr || (rr = 1, (function(i) {
    function s(p) {
      "@babel/helpers - typeof";
      return i.exports = s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
        return typeof v;
      } : function(v) {
        return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, s(p);
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })($e)), $e.exports;
}
var et = { exports: {} }, ir;
function pi() {
  return ir || (ir = 1, (function(i) {
    var s = Ee().default;
    function p(v, _) {
      if (s(v) != "object" || !v) return v;
      var d = v[Symbol.toPrimitive];
      if (d !== void 0) {
        var u = d.call(v, _ || "default");
        if (s(u) != "object") return u;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (_ === "string" ? String : Number)(v);
    }
    i.exports = p, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(et)), et.exports;
}
var nr;
function Vr() {
  return nr || (nr = 1, (function(i) {
    var s = Ee().default, p = pi();
    function v(_) {
      var d = p(_, "string");
      return s(d) == "symbol" ? d : d + "";
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Ze)), Ze.exports;
}
var or;
function _e() {
  return or || (or = 1, (function(i) {
    var s = Vr();
    function p(_, d) {
      for (var u = 0; u < d.length; u++) {
        var g = d[u];
        g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(_, s(g.key), g);
      }
    }
    function v(_, d, u) {
      return d && p(_.prototype, d), u && p(_, u), Object.defineProperty(_, "prototype", {
        writable: !1
      }), _;
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Ye)), Ye.exports;
}
function yi(i) {
  throw new Error('Could not dynamically require "' + i + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var tt = { exports: {} }, sr;
function wi() {
  return sr || (sr = 1, (function(i) {
    (function() {
      Object.assign || Object.defineProperty(Object, "assign", { enumerable: !1, configurable: !0, writable: !0, value: function(v) {
        if (v == null) throw new TypeError("Cannot convert first argument to object");
        for (var _ = Object(v), d = 1; d < arguments.length; d++) {
          var u = arguments[d];
          if (u != null) {
            u = Object(u);
            for (var g = Object.keys(Object(u)), a = 0, k = g.length; k > a; a++) {
              var E = g[a], S = Object.getOwnPropertyDescriptor(u, E);
              S !== void 0 && S.enumerable && (_[E] = u[E]);
            }
          }
        }
        return _;
      } });
      function s(v) {
        let _;
        try {
          _ = window[v];
          const d = "__storage_test__";
          return _.setItem(d, d), _.removeItem(d), !0;
        } catch (d) {
          return DOMException && d instanceof DOMException && (d.name === "QuotaExceededError" || d.name === "QUOTA_EXCEEDED_ERR" || d.name === "NS_ERROR_DOM_QUOTA_REACHED" || d.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || d.toString().indexOf("QuotaExceededError") !== -1) && _ && _.length !== 0;
        }
      }
      var p = function(v) {
        var _ = {
          user_agent: null,
          persist: !0,
          cookie_name_client_id: "ConstructorioID_client_id",
          cookie_name_session_id: "ConstructorioID_session_id",
          cookie_name_session_data: "ConstructorioID_session",
          cookie_domain: null,
          cookie_secure: null,
          // null, true
          cookie_samesite: null,
          // null, Lax, Strict
          cookie_days_to_live: 365,
          local_name_client_id: "_constructorio_search_client_id",
          local_name_session_id: "_constructorio_search_session_id",
          local_name_session_data: "_constructorio_search_session",
          on_node: typeof window > "u",
          session_is_new: null,
          new_to_beacon: null,
          client_id_storage_location: "cookie",
          session_id_storage_location: "local"
        };
        if (Object.assign(this, _, v), !this.client_id)
          if (!this.on_node && this.persist) {
            var d;
            this.client_id_storage_location === "cookie" && (d = this.get_cookie(this.cookie_name_client_id), d && (this.delete_cookie(this.cookie_name_client_id), this.set_cookie(this.cookie_name_client_id, d))), this.client_id_storage_location === "local" && (d = this.get_local_object(this.local_name_client_id)), this.client_id = d || this.generate_client_id();
          } else
            this.client_id = this.generate_client_id();
        this.session_id || (!this.on_node && this.persist ? this.session_id = this.generate_session_id() : this.session_id = 1), this.on_node || (this.user_agent = this.user_agent || window && window.navigator && window.navigator.userAgent);
      };
      p.prototype.set_cookie = function(v, _) {
        if (!this.on_node && this.persist) {
          var d = new Date(Date.now() + this.cookie_days_to_live * 24 * 60 * 60 * 1e3), u = v + "=" + _ + "; expires=" + d.toUTCString() + "; path=/";
          return this.cookie_domain && (u += "; domain=" + this.cookie_domain), this.cookie_secure && (u += "; secure"), this.cookie_samesite && (u += "; samesite=" + this.cookie_samesite), document.cookie = u, u;
        }
        return null;
      }, p.prototype.get_cookie = function(v) {
        for (var _ = v + "=", d = document.cookie.split(";"), u = 0; u < d.length; u++) {
          var g = d[u];
          try {
            for (var a = decodeURIComponent(g); a.charAt(0) === " "; )
              a = a.substring(1);
            if (a.indexOf(_) === 0)
              return a.substring(_.length, a.length);
          } catch {
          }
        }
      }, p.prototype.delete_cookie = function(v) {
        document.cookie = v + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      }, p.prototype.generate_client_id = function() {
        var v;
        if (!this.on_node) {
          var _ = this.get_cookie(this.cookie_name_client_id), d = this.get_local_object(this.local_name_client_id);
          this.client_id_storage_location === "cookie" && d && (v = d, this.set_cookie(this.cookie_name_client_id, v), this.delete_local_object(this.local_name_client_id)), this.client_id_storage_location === "local" && _ && (v = _, this.set_local_object(this.local_name_client_id, v), this.delete_cookie(this.cookie_name_client_id));
        }
        return v || (v = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(u) {
          var g = Math.random() * 16 | 0, a = u === "x" ? g : g & 3 | 8;
          return a.toString(16);
        }), this.client_id_storage_location === "cookie" && this.set_cookie(this.cookie_name_client_id, v), this.client_id_storage_location === "local" && this.set_local_object(this.local_name_client_id, v)), v;
      }, p.prototype.get_local_object = function(v) {
        var _, d = s("localStorage") && window && window.localStorage;
        if (d && typeof v == "string")
          try {
            _ = JSON.parse(d.getItem(v));
          } catch {
            _ = d.getItem(v);
          }
        return _;
      }, p.prototype.set_local_object = function(v, _) {
        var d = s("localStorage") && window && window.localStorage;
        if (d && typeof v == "string") {
          if (typeof _ == "object")
            try {
              d.setItem(v, JSON.stringify(_));
            } catch {
            }
          if (typeof _ == "string" || typeof _ == "number")
            try {
              d.setItem(v, _);
            } catch {
            }
        }
      }, p.prototype.delete_local_object = function(v) {
        var _ = s("localStorage") && window && window.localStorage;
        if (_ && typeof v == "string")
          try {
            _.removeItem(v);
          } catch {
          }
      }, p.prototype.generate_session_id = function() {
        var v = this.get_cookie(this.cookie_name_session_data), _ = this.get_local_object(this.local_name_session_data), d = Date.now(), u = 1e3 * 60 * 30, g;
        if (this.session_id_storage_location === "local" && (g = this.get_local_object(this.local_name_session_data), !g && v && (g = v, this.delete_cookie(this.cookie_name_session_data))), this.session_id_storage_location === "cookie") {
          g = this.get_cookie(this.cookie_name_session_data);
          try {
            g = JSON.parse(g);
          } catch {
          }
          !g && _ && (g = _, this.delete_local_object(this.local_name_session_data));
        }
        var a = 1, k = 1;
        g && typeof g == "object" && (k = parseInt(g.sessionId, 10) || 1, g.lastTime > d - u ? a = k : a = k + 1), this.session_id = a, this.session_is_new = !(g && k === a), g && g.newToBeacon && (this.new_to_beacon = !0);
        const E = {
          sessionId: a,
          lastTime: d
        };
        return this.session_is_new && (E.newToBeacon = !0), this.session_id_storage_location === "local" && (this.set_local_object(this.local_name_session_id, a), this.set_local_object(this.local_name_session_data, E)), this.session_id_storage_location === "cookie" && (this.cookie_domain && (this.delete_cookie(this.cookie_name_session_id), this.delete_cookie(this.cookie_name_session_data)), this.set_cookie(this.cookie_name_session_id, a), this.set_cookie(this.cookie_name_session_data, JSON.stringify(E))), a;
      }, typeof yi < "u" && (i.exports = p);
    })();
  })(tt)), tt.exports;
}
var rt = {};
var ar;
function bi() {
  return ar || (ar = 1, (function(i) {
    (function(s) {
      s(typeof DO_NOT_EXPORT_CRC > "u" ? i : {});
    })(function(s) {
      s.version = "1.2.2";
      function p() {
        for (var r = 0, h = new Array(256), c = 0; c != 256; ++c)
          r = c, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, r = r & 1 ? -306674912 ^ r >>> 1 : r >>> 1, h[c] = r;
        return typeof Int32Array < "u" ? new Int32Array(h) : h;
      }
      var v = p();
      function _(r) {
        var h = 0, c = 0, b = 0, m = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
        for (b = 0; b != 256; ++b) m[b] = r[b];
        for (b = 0; b != 256; ++b)
          for (c = r[b], h = 256 + b; h < 4096; h += 256) c = m[h] = c >>> 8 ^ r[c & 255];
        var A = [];
        for (b = 1; b != 16; ++b) A[b - 1] = typeof Int32Array < "u" ? m.subarray(b * 256, b * 256 + 256) : m.slice(b * 256, b * 256 + 256);
        return A;
      }
      var d = _(v), u = d[0], g = d[1], a = d[2], k = d[3], E = d[4], S = d[5], C = d[6], x = d[7], R = d[8], w = d[9], e = d[10], t = d[11], y = d[12], n = d[13], f = d[14];
      function q(r, h) {
        for (var c = h ^ -1, b = 0, m = r.length; b < m; ) c = c >>> 8 ^ v[(c ^ r.charCodeAt(b++)) & 255];
        return ~c;
      }
      function l(r, h) {
        for (var c = h ^ -1, b = r.length - 15, m = 0; m < b; ) c = f[r[m++] ^ c & 255] ^ n[r[m++] ^ c >> 8 & 255] ^ y[r[m++] ^ c >> 16 & 255] ^ t[r[m++] ^ c >>> 24] ^ e[r[m++]] ^ w[r[m++]] ^ R[r[m++]] ^ x[r[m++]] ^ C[r[m++]] ^ S[r[m++]] ^ E[r[m++]] ^ k[r[m++]] ^ a[r[m++]] ^ g[r[m++]] ^ u[r[m++]] ^ v[r[m++]];
        for (b += 15; m < b; ) c = c >>> 8 ^ v[(c ^ r[m++]) & 255];
        return ~c;
      }
      function o(r, h) {
        for (var c = h ^ -1, b = 0, m = r.length, A = 0, O = 0; b < m; )
          A = r.charCodeAt(b++), A < 128 ? c = c >>> 8 ^ v[(c ^ A) & 255] : A < 2048 ? (c = c >>> 8 ^ v[(c ^ (192 | A >> 6 & 31)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A & 63)) & 255]) : A >= 55296 && A < 57344 ? (A = (A & 1023) + 64, O = r.charCodeAt(b++) & 1023, c = c >>> 8 ^ v[(c ^ (240 | A >> 8 & 7)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A >> 2 & 63)) & 255], c = c >>> 8 ^ v[(c ^ (128 | O >> 6 & 15 | (A & 3) << 4)) & 255], c = c >>> 8 ^ v[(c ^ (128 | O & 63)) & 255]) : (c = c >>> 8 ^ v[(c ^ (224 | A >> 12 & 15)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A >> 6 & 63)) & 255], c = c >>> 8 ^ v[(c ^ (128 | A & 63)) & 255]);
        return ~c;
      }
      s.table = v, s.bstr = q, s.buf = l, s.str = o;
    });
  })(rt)), rt;
}
var it, ur;
function Vt() {
  if (ur) return it;
  ur = 1;
  function i(_) {
    var d;
    try {
      d = window[_];
      var u = "__storage_test__";
      return d.setItem(u, u), d.removeItem(u), !0;
    } catch (g) {
      return typeof DOMException < "u" && g instanceof DOMException && (g.name === "QuotaExceededError" || g.name === "QUOTA_EXCEEDED_ERR" || g.name === "NS_ERROR_DOM_QUOTA_REACHED" || g.toString().indexOf("QUOTA_EXCEEDED_ERR") !== -1 || g.toString().indexOf("QuotaExceededError") !== -1) && d && d.length !== 0;
    }
  }
  var s = {
    overflow: {},
    get: function(d) {
      var u = this.overflow[d];
      if (u)
        return u;
      if (!i("sessionStorage"))
        return null;
      var g = sessionStorage.getItem(d);
      if (g)
        try {
          return JSON.parse(g);
        } catch {
          return g;
        }
      return null;
    },
    set: function(d, u) {
      try {
        sessionStorage.setItem(d, JSON.stringify(u));
      } catch {
        this.overflow[d] = u;
      }
    },
    remove: function(d) {
      var u;
      (u = this.overflow) !== null && u !== void 0 && u[d] && delete this.overflow[d], i("sessionStorage") && sessionStorage.removeItem(d);
    },
    key: function(d) {
      var u, g;
      if (!i("sessionStorage")) {
        var a;
        return (a = Object.keys(this.overflow)) === null || a === void 0 ? void 0 : a[d];
      }
      var k = (u = sessionStorage) === null || u === void 0 ? void 0 : u.key(d), E = ((g = sessionStorage) === null || g === void 0 ? void 0 : g.length) || 0;
      if (d >= E) {
        var S, C = d - E;
        return (S = Object.keys(this.overflow)) === null || S === void 0 ? void 0 : S[C];
      }
      return k;
    },
    length: function() {
      var d = Object.keys(this.overflow).length;
      return i("sessionStorage") ? sessionStorage.length + d : d;
    },
    clear: function() {
      this.overflow = {}, i("sessionStorage") && sessionStorage.clear();
    }
  }, p = {
    overflow: {},
    get: function(d) {
      var u = this.overflow[d];
      if (u)
        return u;
      if (!i("localStorage"))
        return null;
      var g = localStorage.getItem(d);
      if (g)
        try {
          return JSON.parse(g);
        } catch {
          return g;
        }
      return null;
    },
    set: function(d, u) {
      try {
        localStorage.setItem(d, JSON.stringify(u));
      } catch {
        this.overflow[d] = u;
      }
    },
    remove: function(d) {
      var u;
      (u = this.overflow) !== null && u !== void 0 && u[d] && delete this.overflow[d], i("localStorage") && localStorage.removeItem(d);
    },
    key: function(d) {
      var u, g;
      if (!i("localStorage")) {
        var a;
        return (a = Object.keys(this.overflow)) === null || a === void 0 ? void 0 : a[d];
      }
      var k = (u = localStorage) === null || u === void 0 ? void 0 : u.key(d), E = ((g = localStorage) === null || g === void 0 ? void 0 : g.length) || 0;
      if (d >= E) {
        var S, C = d - E;
        return (S = Object.keys(this.overflow)) === null || S === void 0 ? void 0 : S[C];
      }
      return k;
    },
    length: function() {
      var d = Object.keys(this.overflow).length;
      return i("localStorage") ? localStorage.length + d : d;
    },
    clear: function() {
      this.overflow = {}, i("localStorage") && localStorage.clear();
    }
  }, v = {
    local: p,
    session: s,
    canUseStorage: i
  };
  return it = v, it;
}
var nt, cr;
function he() {
  if (cr) return nt;
  cr = 1;
  var i = fe(), s = i(Ee()), p = bi(), v = Vt(), _ = "_constructorio_purchase_order_ids", d = [
    {
      pattern: /[\w\-+\\.]+@([\w-]+\.)+[\w-]{2,4}/,
      replaceWith: "<email_omitted>"
    },
    {
      pattern: /^(?:\+\d{11,12}|\+\d{1,3}\s\d{3}\s\d{3}\s\d{3,4}|\(\d{3}\)\d{7}|\(\d{3}\)\s\d{3}\s\d{4}|\(\d{3}\)\d{3}-\d{4}|\(\d{3}\)\s\d{3}-\d{4})$/,
      replaceWith: "<phone_omitted>"
    },
    {
      pattern: /^(?:4[0-9]{15}|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\d{3})\d{11})$/,
      // Visa, Mastercard, Amex, Discover, JCB and Diners Club, regex source: https://www.regular-expressions.info/creditcard.html
      replaceWith: "<credit_omitted>"
    }
    // Add more PII REGEX
  ], u = {
    trimNonBreakingSpaces: function(a) {
      return a.replace(/\s/g, " ").trim();
    },
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent#encoding_for_rfc3986
    encodeURIComponentRFC3986: function(a) {
      return encodeURIComponent(a).replace(/[!'()*]/g, function(k) {
        return "%".concat(k.charCodeAt(0).toString(16).toUpperCase());
      });
    },
    cleanParams: function(a) {
      var k = {};
      return Object.keys(a).forEach(function(E) {
        var S = a[E];
        typeof S == "string" ? k[E] = u.trimNonBreakingSpaces(S) : k[E] = S;
      }), k;
    },
    throwHttpErrorFromResponse: function(a, k) {
      return k.json().then(function(E) {
        throw a.message = E.message, a.status = k.status, a.statusText = k.statusText, a.url = k.url, a.headers = k.headers, a;
      });
    },
    canUseDOM: function() {
      return !!(typeof window < "u" && window.document && window.document.createElement);
    },
    addEventListener: function(a, k, E) {
      u.canUseDOM() && window.addEventListener(a, k, E);
    },
    removeEventListener: function(a, k, E) {
      u.canUseDOM() && window.removeEventListener(a, k, E);
    },
    getNavigator: function() {
      return u.canUseDOM() ? window.navigator : {
        userAgent: "",
        webdriver: !1
      };
    },
    isNil: function(a) {
      return a == null;
    },
    getWindowLocation: function() {
      return u.canUseDOM() ? window.location : {};
    },
    dispatchEvent: function(a) {
      u.canUseDOM() && window.dispatchEvent(a);
    },
    createCustomEvent: function(a, k) {
      if (u.canUseDOM())
        try {
          return new window.CustomEvent(a, {
            detail: k
          });
        } catch {
          var E = document.createEvent("CustomEvent");
          return E.initCustomEvent(a, !1, !1, k), E;
        }
      return null;
    },
    hasOrderIdRecord: function(a) {
      var k = a.orderId, E = a.apiKey, S = k;
      E && (S = "".concat(E, "-").concat(k));
      var C = p.str(S.toString()), x = v.local.get(_);
      return typeof x == "string" && (x = JSON.parse(x)), x && x.includes(C) ? !0 : null;
    },
    addOrderIdRecord: function(a) {
      var k = a.orderId, E = a.apiKey, S = k;
      E && (S = "".concat(E, "-").concat(k));
      var C = p.str(S.toString()), x = v.local.get(_);
      if (typeof x == "string" && (x = JSON.parse(x)), x) {
        if (x.includes(C))
          return;
        x.length >= 10 && (x = x.slice(-9)), x.push(C);
      } else
        x = [C];
      v.local.set(_, x);
    },
    // Abort network request based on supplied timeout interval (in milliseconds)
    // - method call parameter takes precedence over global options parameter
    applyNetworkTimeout: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, S = a && a.networkParameters && a.networkParameters.timeout, C = k && k.timeout, x = C || S;
      typeof x == "number" && E && setTimeout(function() {
        return E.abort();
      }, x);
    },
    stringify: function(a, k, E) {
      if (!a)
        return "";
      var S = [];
      return Object.keys(a).forEach(function(C) {
        var x = a[C], R = u.encodeURIComponentRFC3986(C), w;
        if (x != null) {
          var e = k ? "".concat(k, "%5B").concat(R, "%5D") : R;
          Array.isArray(x) ? w = u.stringify(x, e, "array") : (0, s.default)(x) === "object" ? w = u.stringify(x, e, "object") : E === "object" ? w = "".concat(e, "=").concat(u.encodeURIComponentRFC3986(x)) : w = "".concat(k || R, "=").concat(u.encodeURIComponentRFC3986(x)), S.push(w);
        }
      }), S.join("&");
    },
    toSnakeCase: function(a) {
      return a.replace(/[A-Z]/g, function(k) {
        return "_".concat(k.toLowerCase());
      });
    },
    toSnakeCaseKeys: function(a) {
      var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, E = {};
      return Object.keys(a).forEach(function(S) {
        var C = u.toSnakeCase(S);
        E[C] = k && (0, s.default)(a[S]) === "object" && !Array.isArray(a[S]) ? u.toSnakeCaseKeys(a[S], k) : a[S];
      }), E;
    },
    containsPii: function(a, k) {
      var E = a.toLowerCase();
      return k.test(E);
    },
    obfuscatePiiRequest: function(a) {
      var k = a;
      try {
        var E, S, C, x = new URL(a), R = x == null || (E = x.pathname) === null || E === void 0 ? void 0 : E.split("/"), w = x == null || (S = x.search) === null || S === void 0 || (C = S.split("&")) === null || C === void 0 ? void 0 : C.map(function(e) {
          var t;
          return (t = e.split("=")) === null || t === void 0 ? void 0 : t[1];
        });
        d.forEach(function(e) {
          var t = e.pattern, y = e.replaceWith;
          R.forEach(function(n) {
            var f = decodeURIComponent(n);
            u.containsPii(f, t) && (k = k.replaceAll(n, y));
          }), w.forEach(function(n) {
            var f = decodeURIComponent(n);
            u.containsPii(f, t) && (k = k.replaceAll(f, y));
          });
        });
      } catch {
      }
      return k;
    },
    convertResponseToJson: function(a) {
      return a.ok ? a.json().catch(function() {
        return a.text().then(function(k) {
          throw new Error("Server responded with an invalid JSON object. Response code: ".concat(a.code, ", Response: ").concat(k));
        });
      }) : u.throwHttpErrorFromResponse(new Error(), a);
    },
    addHTTPSToString: function(a) {
      if (typeof a != "string")
        return null;
      var k = a.startsWith("https://"), E = a.startsWith("http://");
      if (!k && E)
        return a.replace("http", "https");
      if (!E && !k) {
        var S = "https://".concat(a);
        return S;
      }
      return a;
    },
    truncateString: function(a, k) {
      return a.slice(0, k);
    }
  };
  return nt = u, nt;
}
var ot, lr;
function Ie() {
  if (lr) return ot;
  lr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = he(), _ = /* @__PURE__ */ (function() {
    function d(u) {
      var g = this;
      (0, s.default)(this, d), this.events = [], this.enabled = !(u && u.enabled === !1), this.waitForBeacon = !(u && u.waitForBeacon === !1), this.active = this.enabled, this.waitForBeacon && (this.active = !1, v.canUseDOM() && (window.ConstructorioAutocomplete || window.ConstructorioBeacon || window.ConstructorioTracker) && this.enabled && (this.active = !0, this.dispatchEvents()), v.addEventListener("cio.beacon.loaded", function() {
        g.enabled && (g.active = !0, g.dispatchEvents());
      }));
    }
    return (0, p.default)(d, [{
      key: "queue",
      value: function(g, a) {
        this.events.push({
          name: g,
          data: a
        }), this.active && this.dispatchEvents();
      }
      // Dispatch all custom events within queue on `window` of supplied name with data
    }, {
      key: "dispatchEvents",
      value: function() {
        for (; this.events.length; ) {
          var g = this.events.shift(), a = g.name, k = g.data, E = "cio.client.".concat(a);
          v.dispatchEvent(v.createCustomEvent(E, k));
        }
      }
    }]), d;
  })();
  return ot = _, ot;
}
var st, fr;
function mi() {
  if (fr) return st;
  fr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = Ie(), _ = he();
  function d(g, a, k) {
    var E = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, S = k.apiKey, C = k.version, x = k.serviceUrl, R = k.sessionId, w = k.clientId, e = k.userId, t = k.segments, y = k.testCells, n = {
      c: C
    };
    if (n.key = S, n.i = w, n.s = R, !g || typeof g != "string")
      throw new Error("query is a required parameter of type string");
    if (y && Object.keys(y).forEach(function(D) {
      n["ef-".concat(D)] = y[D];
    }), t && t.length && (n.us = t), e && (n.ui = String(e)), a) {
      var f = a.offset, q = a.page, l = a.resultsPerPage, o = a.filters, r = a.sortBy, h = a.sortOrder, c = a.section, b = a.fmtOptions, m = a.hiddenFields, A = a.hiddenFacets, O = a.variationsMap, U = a.qsParam, N = a.preFilterExpression, I = a.filterMatchTypes;
      _.isNil(f) || (n.offset = f), _.isNil(q) || (n.page = q), _.isNil(l) || (n.num_results_per_page = l), o && (n.filters = o), I && (n.filter_match_types = I), r && (n.sort_by = r), h && (n.sort_order = h), c && (n.section = c), b && (n.fmt_options = b), m && (n.fmt_options ? n.fmt_options.hidden_fields = m : n.fmt_options = {
        hidden_fields: m
      }), A && (n.fmt_options ? n.fmt_options.hidden_facets = A : n.fmt_options = {
        hidden_facets: A
      }), O && (n.variations_map = JSON.stringify(O)), N && (n.pre_filter_expression = JSON.stringify(N)), U && (n.qs = JSON.stringify(U));
    }
    n._dt = Date.now(), n = _.cleanParams(n);
    var L = _.stringify(n), j = E ? "search/natural_language" : "search";
    return "".concat(x, "/").concat(j, "/").concat(_.encodeURIComponentRFC3986(_.trimNonBreakingSpaces(g)), "?").concat(L);
  }
  var u = /* @__PURE__ */ (function() {
    function g(a) {
      (0, s.default)(this, g), this.options = a || {}, this.eventDispatcher = new v(a.eventDispatcher);
    }
    return (0, p.default)(g, [{
      key: "getSearchResults",
      value: function(k, E) {
        var S = this, C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, x, R = this.options.fetch, w;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          w = e && e.signal, _.applyNetworkTimeout(this.options, C, e);
        }
        try {
          x = d(k, E, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return R(x, {
          signal: w
        }).then(_.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(y) {
              y.result_id = t.result_id;
            }), S.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          if (t.response && t.response.redirect)
            return S.eventDispatcher.queue("search.getSearchResults.completed", t), t;
          throw new Error("getSearchResults response data is malformed");
        });
      }
      /**
       * Retrieve voice search results from API
       *
       * @function getVoiceSearchResults
       * @description Retrieve voice search results from Constructor.io API
       * @param {string} query - Term to use to perform a voice search
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/search-search-resultsqueries for details
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope search results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.qsParam] - Parameters listed above can be serialized into a JSON object and parsed through this parameter. Please refer to https://docs.constructor.com/reference/v1-search-get-search-results
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/docs/products-search-learn-about-search
       * @example
       * constructorio.search.getVoiceSearchResults('show me lipstick');
       */
    }, {
      key: "getVoiceSearchResults",
      value: function(k, E) {
        var S = this, C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, x, R = this.options.fetch, w;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          w = e && e.signal, _.applyNetworkTimeout(this.options, C, e);
        }
        try {
          var t = !0;
          x = d(k, E, this.options, t);
        } catch (y) {
          return Promise.reject(y);
        }
        return R(x, {
          signal: w
        }).then(_.convertResponseToJson).then(function(y) {
          if (y.response && y.response.results)
            return y.result_id && y.response.results.forEach(function(n) {
              n.result_id = y.result_id;
            }), S.eventDispatcher.queue("search.getVoiceSearchResults.completed", y), y;
          if (y.response && y.response.redirect)
            return S.eventDispatcher.queue("search.getVoiceSearchResults.completed", y), y;
          throw new Error("getVoiceSearchResults response data is malformed");
        });
      }
    }]), g;
  })();
  return st = u, st;
}
var at = { exports: {} }, dr;
function Ve() {
  return dr || (dr = 1, (function(i) {
    var s = Vr();
    function p(v, _, d) {
      return (_ = s(_)) in v ? Object.defineProperty(v, _, {
        value: d,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : v[_] = d, v;
    }
    i.exports = p, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(at)), at.exports;
}
var ut, vr;
function ki() {
  if (vr) return ut;
  vr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = i(Ve());
  function _(R, w) {
    var e = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(R);
      w && (t = t.filter(function(y) {
        return Object.getOwnPropertyDescriptor(R, y).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function d(R) {
    for (var w = 1; w < arguments.length; w++) {
      var e = arguments[w] != null ? arguments[w] : {};
      w % 2 ? _(Object(e), !0).forEach(function(t) {
        (0, v.default)(R, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(e)) : _(Object(e)).forEach(function(t) {
        Object.defineProperty(R, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return R;
  }
  var u = Ie(), g = he();
  function a(R, w) {
    var e = w.apiKey, t = w.version, y = w.sessionId, n = w.clientId, f = w.userId, q = w.segments, l = w.testCells, o = {
      c: t
    };
    if (o.key = e, o.i = n, o.s = y, l && Object.keys(l).forEach(function(F) {
      o["ef-".concat(F)] = l[F];
    }), q && q.length && (o.us = q), f && (o.ui = String(f)), R) {
      var r = R.page, h = R.offset, c = R.resultsPerPage, b = R.filters, m = R.sortBy, A = R.sortOrder, O = R.section, U = R.fmtOptions, N = R.hiddenFields, I = R.hiddenFacets, L = R.variationsMap, j = R.qsParam, D = R.preFilterExpression, P = R.filterMatchTypes;
      g.isNil(r) || (o.page = r), g.isNil(h) || (o.offset = h), g.isNil(c) || (o.num_results_per_page = c), b && (o.filters = b), P && (o.filter_match_types = P), m && (o.sort_by = m), A && (o.sort_order = A), O && (o.section = O), U && (o.fmt_options = U), N && (o.fmt_options ? o.fmt_options.hidden_fields = N : o.fmt_options = {
        hidden_fields: N
      }), I && (o.fmt_options ? o.fmt_options.hidden_facets = I : o.fmt_options = {
        hidden_facets: I
      }), L && (o.variations_map = JSON.stringify(L)), D && (o.pre_filter_expression = JSON.stringify(D)), j && (o.qs = JSON.stringify(j));
    }
    return o._dt = Date.now(), o = g.cleanParams(o), o;
  }
  function k(R, w, e, t) {
    var y = t.serviceUrl;
    if (!R || typeof R != "string")
      throw new Error("filterName is a required parameter of type string");
    if (!w || typeof w != "string")
      throw new Error("filterValue is a required parameter of type string");
    var n = a(e, t), f = g.stringify(n);
    return "".concat(y, "/browse/").concat(g.encodeURIComponentRFC3986(g.trimNonBreakingSpaces(R)), "/").concat(g.encodeURIComponentRFC3986(g.trimNonBreakingSpaces(w)), "?").concat(f);
  }
  function E(R, w, e) {
    var t = e.serviceUrl;
    if (!R || !Array.isArray(R) || !R.length)
      throw new Error("ids is a required parameter of type array");
    var y = d(d({}, a(w, e)), {}, {
      ids: R
    }), n = g.stringify(y);
    return "".concat(t, "/browse/items?").concat(n);
  }
  function S(R, w) {
    var e = w.serviceUrl, t = d({}, a(R, w));
    delete t._dt;
    var y = g.stringify(t);
    return "".concat(e, "/browse/facets?").concat(y);
  }
  function C(R, w, e) {
    var t = e.serviceUrl;
    if (!R || typeof R != "string")
      throw new Error("facetName is a required parameter of type string");
    var y = d({}, a(w, e));
    y.facet_name = R, delete y._dt;
    var n = g.stringify(y);
    return "".concat(t, "/browse/facet_options?").concat(n);
  }
  var x = /* @__PURE__ */ (function() {
    function R(w) {
      (0, s.default)(this, R), this.options = w || {}, this.eventDispatcher = new u(w.eventDispatcher);
    }
    return (0, p.default)(R, [{
      key: "getBrowseResults",
      value: function(e, t, y) {
        var n = this, f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, q, l = this.options.fetch, o;
        if (typeof AbortController == "function") {
          var r = new AbortController();
          o = r && r.signal, g.applyNetworkTimeout(this.options, f, r);
        }
        try {
          q = k(e, t, y, this.options);
        } catch (h) {
          return Promise.reject(h);
        }
        return l(q, {
          signal: o
        }).then(g.convertResponseToJson).then(function(h) {
          if (h.response && h.response.results)
            return h.result_id && h.response.results.forEach(function(c) {
              c.result_id = h.result_id;
            }), n.eventDispatcher.queue("browse.getBrowseResults.completed", h), h;
          throw new Error("getBrowseResults response data is malformed");
        });
      }
      /**
       * Retrieve browse results from API using item id's
       *
       * @function getBrowseResultsForItemIds
       * @param {string[]} itemIds - Item id's of results to fetch
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-results for details
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {string[]} [parameters.hiddenFacets] - Hidden facets to return
       * @param {object} [parameters.variationsMap] - The variations map object to aggregate variations. Please refer to https://docs.constructor.com/reference/shared-variations-mapping for details
       * @param {object} [parameters.filterMatchTypes] - An object specifying whether results must match `all`, `any` or `none` of a given filter. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @param {object} [parameters.preFilterExpression] - Faceting expression to scope browse results. Please refer to https://docs.constructor.com/reference/configuration-collections
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-items-results
       * @example
       * constructorio.browse.getBrowseResultsForItemIds(['shirt-123', 'shirt-456', 'shirt-789'], {
       *     filters: {
       *         size: 'medium'
       *     },
       *     filterMatchTypes: {
       *        size: 'all'
       *     }
       * });
       */
    }, {
      key: "getBrowseResultsForItemIds",
      value: function(e, t) {
        var y = this, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f, q = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, n, o);
        }
        try {
          f = E(e, t, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return q(f, {
          signal: l
        }).then(g.convertResponseToJson).then(function(r) {
          if (r.response && r.response.results)
            return r.result_id && r.response.results.forEach(function(h) {
              h.result_id = r.result_id;
            }), y.eventDispatcher.queue("browse.getBrowseResultsForItemIds.completed", r), r;
          throw new Error("getBrowseResultsForItemIds response data is malformed");
        });
      }
      /**
       * Retrieve browse groups from API
       *
       * @function getBrowseGroups
       * @param {object} [parameters.filters] - Filters used to refine results
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-groups/ for details
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-groups
       * @example
       * constructorio.browse.getBrowseGroups({
       *     filters: {
       *         group_id: 'drill_collection'
       *     },
       *     fmtOptions: {
       *         groups_max_depth: 2
       *     }
       * });
       */
    }, {
      key: "getBrowseGroups",
      value: function(e) {
        var t = this, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = this.options.fetch, f = this.options.serviceUrl, q = a(e, this.options), l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, y, o);
        }
        delete q._dt;
        var r = g.stringify(q), h = "".concat(f, "/browse/groups?").concat(r);
        return n(h, {
          signal: l
        }).then(g.convertResponseToJson).then(function(c) {
          if (c.response && c.response.groups)
            return t.eventDispatcher.queue("browse.getBrowseGroups.completed", c), c;
          throw new Error("getBrowseGroups response data is malformed");
        });
      }
      /**
       * Retrieve browse facets from API
       *
       * @function getBrowseFacets
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {number} [parameters.page] - The page number of the results (Can't be used together with offset)
       * @param {number} [parameters.offset] - The number of results to skip from the beginning (Can't be used together with page)
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/browse-browse-facets/ for details
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/browse-browse-facets
       * @example
       * constructorio.browse.getBrowseFacets({
       *     page: 1,
       *     resultsPerPage: 10,
       * });
       */
    }, {
      key: "getBrowseFacets",
      value: function(e, t) {
        var y = this, n, f = this.options.fetch, q;
        if (typeof AbortController == "function") {
          var l = new AbortController();
          q = l && l.signal, g.applyNetworkTimeout(this.options, t, l);
        }
        try {
          n = S(e, this.options);
        } catch (o) {
          return Promise.reject(o);
        }
        return f(n, {
          signal: q
        }).then(g.convertResponseToJson).then(function(o) {
          if (o.response && o.response.facets)
            return y.eventDispatcher.queue("browse.getBrowseFacets.completed", o), o;
          throw new Error("getBrowseFacets response data is malformed");
        });
      }
      /**
       * Retrieve facet options from API
       *
       * @function getBrowseFacetOptions
       * @param {string} facetName - Name of the facet whose options to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {object} [parameters] - Additional parameters to refine result set
       * @param {string} [parameters.section='Products'] - The section name for results
       * @param {object} [parameters.fmtOptions] - The format options used to refine result groups. Please refer to https://docs.constructor.com/reference/v1-browse-get-browse-facet-options for details
       * @param {}
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-browse-get-browse-facet-options
       * @example
       * constructorio.browse.getBrowseFacetOptions('price', {
       * });
       */
    }, {
      key: "getBrowseFacetOptions",
      value: function(e) {
        var t = this, y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, f, q = this.options.fetch, l;
        if (typeof AbortController == "function") {
          var o = new AbortController();
          l = o && o.signal, g.applyNetworkTimeout(this.options, n, o);
        }
        try {
          f = C(e, y, this.options);
        } catch (r) {
          return Promise.reject(r);
        }
        return q(f, {
          signal: l
        }).then(g.convertResponseToJson).then(function(r) {
          if (r.response && r.response.facets)
            return t.eventDispatcher.queue("browse.getBrowseFacetOptions.completed", r), r;
          throw new Error("getBrowseFacetOptions response data is malformed");
        });
      }
    }]), R;
  })();
  return ut = x, ut;
}
var ct, hr;
function Si() {
  if (hr) return ct;
  hr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = Ie(), _ = he(), d = _.convertResponseToJson, u = _.cleanParams, g = _.applyNetworkTimeout, a = _.trimNonBreakingSpaces, k = _.encodeURIComponentRFC3986, E = _.stringify;
  function S(x, R, w) {
    var e = w.apiKey, t = w.version, y = w.serviceUrl, n = w.sessionId, f = w.clientId, q = w.userId, l = w.segments, o = w.testCells, r = {
      c: t
    };
    if (r.key = e, r.i = f, r.s = n, !x || typeof x != "string")
      throw new Error("query is a required parameter of type string");
    if (o && Object.keys(o).forEach(function(D) {
      r["ef-".concat(D)] = o[D];
    }), l && l.length && (r.us = l), q && (r.ui = String(q)), R) {
      var h = R.numResults, c = R.resultsPerSection, b = R.filters, m = R.filtersPerSection, A = R.hiddenFields, O = R.variationsMap, U = R.preFilterExpression, N = R.qsParam, I = R.fmtOptions;
      h && (r.num_results = h), c && Object.keys(c).forEach(function(D) {
        r["num_results_".concat(D)] = c[D];
      }), b && (r.filters = b), m && Object.keys(m).forEach(function(D) {
        r["filters[".concat(D, "]")] = m[D];
      }), U && (r.pre_filter_expression = JSON.stringify(U)), I && (r.fmt_options = I), A && (r.fmt_options ? r.fmt_options.hidden_fields = A : r.fmt_options = {
        hidden_fields: A
      }), O && (r.variations_map = JSON.stringify(O)), N && (r.qs = JSON.stringify(N));
    }
    r._dt = Date.now(), r = u(r);
    var L = E(r), j = x.replace(/^\//, "|");
    return "".concat(y, "/autocomplete/").concat(k(a(j)), "?").concat(L);
  }
  var C = /* @__PURE__ */ (function() {
    function x(R) {
      (0, s.default)(this, x), this.options = R || {}, this.eventDispatcher = new v(R.eventDispatcher);
    }
    return (0, p.default)(x, [{
      key: "getAutocompleteResults",
      value: function(w, e) {
        var t = this, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n, f = this.options.fetch, q;
        if (typeof AbortController == "function") {
          var l = new AbortController();
          q = l && l.signal, g(this.options, y, l);
        }
        try {
          n = S(w, e, this.options);
        } catch (o) {
          return Promise.reject(o);
        }
        return f(n, {
          signal: q
        }).then(d).then(function(o) {
          if (o.sections) {
            if (o.result_id) {
              var r = Object.keys(o.sections);
              r.forEach(function(h) {
                var c = o.sections[h];
                c.length && c.forEach(function(b) {
                  b.result_id = o.result_id;
                });
              });
            }
            return t.eventDispatcher.queue("autocomplete.getAutocompleteResults.completed", o), o;
          }
          throw new Error("getAutocompleteResults response data is malformed");
        });
      }
    }]), x;
  })();
  return ct = C, ct;
}
var lt, gr;
function qi() {
  if (gr) return lt;
  gr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = Ie(), _ = he();
  function d(g, a, k) {
    var E = k.apiKey, S = k.version, C = k.serviceUrl, x = k.sessionId, R = k.userId, w = k.clientId, e = k.segments, t = {
      c: S
    };
    if (t.key = E, t.i = w, t.s = x, !g || typeof g != "string")
      throw new Error("podId is a required parameter of type string");
    if (e && e.length && (t.us = e), R && (t.ui = String(R)), a) {
      var y = a.numResults, n = a.itemIds, f = a.section, q = a.term, l = a.filters, o = a.variationsMap, r = a.hiddenFields, h = a.preFilterExpression, c = a.fmtOptions;
      _.isNil(y) || (t.num_results = y), n && (t.item_id = n), f && (t.section = f), q && (t.term = q), l && (t.filters = l), c && (t.fmt_options = c), r && (t.fmt_options ? t.fmt_options.hidden_fields = r : t.fmt_options = {
        hidden_fields: r
      }), o && (t.variations_map = JSON.stringify(o)), h && (t.pre_filter_expression = JSON.stringify(h));
    }
    t = _.cleanParams(t);
    var b = _.stringify(t);
    return "".concat(C, "/recommendations/v1/pods/").concat(_.encodeURIComponentRFC3986(_.trimNonBreakingSpaces(g)), "?").concat(b);
  }
  var u = /* @__PURE__ */ (function() {
    function g(a) {
      (0, s.default)(this, g), this.options = a || {}, this.eventDispatcher = new v(a.eventDispatcher);
    }
    return (0, p.default)(g, [{
      key: "getRecommendations",
      value: function(k, E) {
        var S = this, C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, x, R = this.options.fetch, w;
        if (typeof AbortController == "function") {
          var e = new AbortController();
          w = e && e.signal, _.applyNetworkTimeout(this.options, C, e);
        }
        try {
          x = d(k, E, this.options);
        } catch (t) {
          return Promise.reject(t);
        }
        return R(x, {
          signal: w
        }).then(_.convertResponseToJson).then(function(t) {
          if (t.response && t.response.results)
            return t.result_id && t.response.results.forEach(function(y) {
              y.result_id = t.result_id;
            }), S.eventDispatcher.queue("recommendations.getRecommendations.completed", t), t;
          throw new Error("getRecommendations response data is malformed");
        });
      }
    }]), g;
  })();
  return lt = u, lt;
}
var Ke = { exports: {} }, _r;
function Ri() {
  if (_r) return Ke.exports;
  _r = 1;
  var i = fe(), s = i(Ee()), p = (typeof Reflect > "u" ? "undefined" : (0, s.default)(Reflect)) === "object" ? Reflect : null, v = p && typeof p.apply == "function" ? p.apply : function(o, r, h) {
    return Function.prototype.apply.call(o, r, h);
  }, _;
  p && typeof p.ownKeys == "function" ? _ = p.ownKeys : Object.getOwnPropertySymbols ? _ = function(o) {
    return Object.getOwnPropertyNames(o).concat(Object.getOwnPropertySymbols(o));
  } : _ = function(o) {
    return Object.getOwnPropertyNames(o);
  };
  function d(l) {
    console && console.warn && console.warn(l);
  }
  var u = Number.isNaN || function(o) {
    return o !== o;
  };
  function g() {
    g.init.call(this);
  }
  Ke.exports = g, Ke.exports.once = n, g.EventEmitter = g, g.prototype._events = void 0, g.prototype._eventsCount = 0, g.prototype._maxListeners = void 0;
  var a = 10;
  function k(l) {
    if (typeof l != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + (0, s.default)(l));
  }
  Object.defineProperty(g, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(o) {
      if (typeof o != "number" || o < 0 || u(o))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + o + ".");
      a = o;
    }
  }), g.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, g.prototype.setMaxListeners = function(o) {
    if (typeof o != "number" || o < 0 || u(o))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + o + ".");
    return this._maxListeners = o, this;
  };
  function E(l) {
    return l._maxListeners === void 0 ? g.defaultMaxListeners : l._maxListeners;
  }
  g.prototype.getMaxListeners = function() {
    return E(this);
  }, g.prototype.emit = function(o) {
    for (var r = [], h = 1; h < arguments.length; h++)
      r.push(arguments[h]);
    var c = o === "error", b = this._events;
    if (b !== void 0) c = c && b.error === void 0;
    else if (!c) return !1;
    if (c) {
      var m;
      if (r.length > 0 && (m = r[0]), m instanceof Error)
        throw m;
      var A = new Error("Unhandled error." + (m ? " (" + m.message + ")" : ""));
      throw A.context = m, A;
    }
    var O = b[o];
    if (O === void 0) return !1;
    if (typeof O == "function")
      v(O, this, r);
    else
      for (var U = O.length, N = e(O, U), h = 0; h < U; ++h)
        v(N[h], this, r);
    return !0;
  };
  function S(l, o, r, h) {
    var c, b, m;
    if (k(r), b = l._events, b === void 0 ? (b = l._events = /* @__PURE__ */ Object.create(null), l._eventsCount = 0) : (b.newListener !== void 0 && (l.emit("newListener", o, r.listener ? r.listener : r), b = l._events), m = b[o]), m === void 0)
      m = b[o] = r, ++l._eventsCount;
    else if (typeof m == "function" ? m = b[o] = h ? [r, m] : [m, r] : h ? m.unshift(r) : m.push(r), c = E(l), c > 0 && m.length > c && !m.warned) {
      m.warned = !0;
      var A = new Error("Possible EventEmitter memory leak detected. " + m.length + " " + String(o) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      A.name = "MaxListenersExceededWarning", A.emitter = l, A.type = o, A.count = m.length, d(A);
    }
    return l;
  }
  g.prototype.addListener = function(o, r) {
    return S(this, o, r, !1);
  }, g.prototype.on = g.prototype.addListener, g.prototype.prependListener = function(o, r) {
    return S(this, o, r, !0);
  };
  function C() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function x(l, o, r) {
    var h = {
      fired: !1,
      wrapFn: void 0,
      target: l,
      type: o,
      listener: r
    }, c = C.bind(h);
    return c.listener = r, h.wrapFn = c, c;
  }
  g.prototype.once = function(o, r) {
    return k(r), this.on(o, x(this, o, r)), this;
  }, g.prototype.prependOnceListener = function(o, r) {
    return k(r), this.prependListener(o, x(this, o, r)), this;
  }, g.prototype.removeListener = function(o, r) {
    var h, c, b, m, A;
    if (k(r), c = this._events, c === void 0) return this;
    if (h = c[o], h === void 0) return this;
    if (h === r || h.listener === r)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[o], c.removeListener && this.emit("removeListener", o, h.listener || r));
    else if (typeof h != "function") {
      for (b = -1, m = h.length - 1; m >= 0; m--)
        if (h[m] === r || h[m].listener === r) {
          A = h[m].listener, b = m;
          break;
        }
      if (b < 0) return this;
      b === 0 ? h.shift() : t(h, b), h.length === 1 && (c[o] = h[0]), c.removeListener !== void 0 && this.emit("removeListener", o, A || r);
    }
    return this;
  }, g.prototype.off = g.prototype.removeListener, g.prototype.removeAllListeners = function(o) {
    var r, h, c;
    if (h = this._events, h === void 0) return this;
    if (h.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : h[o] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete h[o]), this;
    if (arguments.length === 0) {
      var b = Object.keys(h), m;
      for (c = 0; c < b.length; ++c)
        m = b[c], m !== "removeListener" && this.removeAllListeners(m);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (r = h[o], typeof r == "function")
      this.removeListener(o, r);
    else if (r !== void 0)
      for (c = r.length - 1; c >= 0; c--)
        this.removeListener(o, r[c]);
    return this;
  };
  function R(l, o, r) {
    var h = l._events;
    if (h === void 0) return [];
    var c = h[o];
    return c === void 0 ? [] : typeof c == "function" ? r ? [c.listener || c] : [c] : r ? y(c) : e(c, c.length);
  }
  g.prototype.listeners = function(o) {
    return R(this, o, !0);
  }, g.prototype.rawListeners = function(o) {
    return R(this, o, !1);
  }, g.listenerCount = function(l, o) {
    return typeof l.listenerCount == "function" ? l.listenerCount(o) : w.call(l, o);
  }, g.prototype.listenerCount = w;
  function w(l) {
    var o = this._events;
    if (o !== void 0) {
      var r = o[l];
      if (typeof r == "function")
        return 1;
      if (r !== void 0)
        return r.length;
    }
    return 0;
  }
  g.prototype.eventNames = function() {
    return this._eventsCount > 0 ? _(this._events) : [];
  };
  function e(l, o) {
    for (var r = new Array(o), h = 0; h < o; ++h)
      r[h] = l[h];
    return r;
  }
  function t(l, o) {
    for (; o + 1 < l.length; o++)
      l[o] = l[o + 1];
    l.pop();
  }
  function y(l) {
    for (var o = new Array(l.length), r = 0; r < o.length; ++r)
      o[r] = l[r].listener || l[r];
    return o;
  }
  function n(l, o) {
    return new Promise(function(r, h) {
      function c(m) {
        l.removeListener(o, b), h(m);
      }
      function b() {
        typeof l.removeListener == "function" && l.removeListener("error", c), r([].slice.call(arguments));
      }
      q(l, o, b, {
        once: !0
      }), o !== "error" && f(l, c, {
        once: !0
      });
    });
  }
  function f(l, o, r) {
    typeof l.on == "function" && q(l, "error", o, r);
  }
  function q(l, o, r, h) {
    if (typeof l.on == "function")
      h.once ? l.once(o, r) : l.on(o, r);
    else if (typeof l.addEventListener == "function")
      l.addEventListener(o, function c(b) {
        h.once && l.removeEventListener(o, c), r(b);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (0, s.default)(l));
  }
  return Ke.exports;
}
var ft, pr;
function Ei() {
  return pr || (pr = 1, ft = ["Googlebot/", "Googlebot-Mobile", "Googlebot-Image", "Googlebot-News", "Googlebot-Video", "AdsBot-Google([^-]|$)", "AdsBot-Google-Mobile", "Feedfetcher-Google", "Mediapartners-Google", "Mediapartners \\(Googlebot\\)", "APIs-Google", "bingbot", "Slurp", "[wW]get", "curl", "LinkedInBot", "Python-urllib", "python-requests", "libwww", "httpunit", "nutch", "Go-http-client", "phpcrawl", "msnbot", "jyxobot", "FAST-WebCrawler", "FAST Enterprise Crawler", "BIGLOTRON", "Teoma", "convera", "seekbot", "Gigabot", "Gigablast", "exabot", "ia_archiver", "GingerCrawler", "webmon ", "HTTrack", "grub\\.org", "UsineNouvelleCrawler", "antibot", "netresearchserver", "speedy", "fluffy", "bibnum\\.bnf", "findlink", "msrbot", "panscient", "yacybot", "AISearchBot", "ips-agent", "tagoobot", "MJ12bot", "woriobot", "yanga", "buzzbot", "mlbot", "YandexBot", "yandex\\.com/bots", "purebot", "Linguee Bot", "CyberPatrol", "voilabot", "Baiduspider", "citeseerxbot", "spbot", "twengabot", "postrank", "turnitinbot", "scribdbot", "page2rss", "sitebot", "linkdex", "Adidxbot", "blekkobot", "ezooms", "dotbot", "Mail\\.RU_Bot", "discobot", "heritrix", "findthatfile", "europarchive\\.org", "NerdByNature\\.Bot", "sistrix crawler", "Ahrefs(Bot|SiteAudit)", "fuelbot", "CrunchBot", "centurybot9", "IndeedBot", "mappydata", "woobot", "ZoominfoBot", "PrivacyAwareBot", "Multiviewbot", "SWIMGBot", "Grobbot", "eright", "Apercite", "semanticbot", "Aboundex", "domaincrawler", "wbsearchbot", "summify", "CCBot", "edisterbot", "seznambot", "ec2linkfinder", "gslfbot", "aiHitBot", "intelium_bot", "facebookexternalhit", "Yeti", "RetrevoPageAnalyzer", "lb-spider", "Sogou", "lssbot", "careerbot", "wotbox", "wocbot", "ichiro", "DuckDuckBot", "lssrocketcrawler", "drupact", "webcompanycrawler", "acoonbot", "openindexspider", "gnam gnam spider", "web-archive-net\\.com\\.bot", "backlinkcrawler", "coccoc", "integromedb", "content crawler spider", "toplistbot", "it2media-domain-crawler", "ip-web-crawler\\.com", "siteexplorer\\.info", "elisabot", "proximic", "changedetection", "arabot", "WeSEE:Search", "niki-bot", "CrystalSemanticsBot", "rogerbot", "360Spider", "psbot", "InterfaxScanBot", "CC Metadata Scaper", "g00g1e\\.net", "GrapeshotCrawler", "urlappendbot", "brainobot", "fr-crawler", "binlar", "SimpleCrawler", "Twitterbot", "cXensebot", "smtbot", "bnf\\.fr_bot", "A6-Indexer", "ADmantX", "Facebot", "OrangeBot/", "memorybot", "AdvBot", "MegaIndex", "SemanticScholarBot", "ltx71", "nerdybot", "xovibot", "BUbiNG", "Qwantify", "archive\\.org_bot", "Applebot", "TweetmemeBot", "crawler4j", "findxbot", "S[eE][mM]rushBot", "yoozBot", "lipperhey", "Y!J", "Domain Re-Animator Bot", "AddThis", "Screaming Frog SEO Spider", "MetaURI", "Scrapy", "Livelap[bB]ot", "OpenHoseBot", "CapsuleChecker", "collection@infegy\\.com", "IstellaBot", "DeuSu/", "betaBot", "Cliqzbot/", "MojeekBot/", "netEstate NE Crawler", "SafeSearch microdata crawler", "Gluten Free Crawler/", "Sonic", "Sysomos", "Trove", "deadlinkchecker", "Slack-ImgProxy", "Embedly", "RankActiveLinkBot", "iskanie", "SafeDNSBot", "SkypeUriPreview", "Veoozbot", "Slackbot", "redditbot", "datagnionbot", "Google-Adwords-Instant", "adbeat_bot", "WhatsApp", "contxbot", "pinterest", "electricmonk", "GarlikCrawler", "BingPreview/", "vebidoobot", "FemtosearchBot", "Yahoo Link Preview", "MetaJobBot", "DomainStatsBot", "mindUpBot", "Daum/", "Jugendschutzprogramm-Crawler", "Xenu Link Sleuth", "Pcore-HTTP", "moatbot", "KosmioBot", "pingdom", "PhantomJS", "Gowikibot", "PiplBot", "Discordbot", "TelegramBot", "Jetslide", "newsharecounts", "James BOT", "Barkrowler", "TinEye", "SocialRankIOBot", "trendictionbot", "Ocarinabot", "epicbot", "Primalbot", "DuckDuckGo-Favicons-Bot", "GnowitNewsbot", "Leikibot", "LinkArchiver", "YaK/", "PaperLiBot", "Digg Deeper", "dcrawl", "Snacktory", "AndersPinkBot", "Fyrebot", "EveryoneSocialBot", "Mediatoolkitbot", "Luminator-robots", "ExtLinksBot", "SurveyBot", "NING/", "okhttp", "Nuzzel", "omgili", "PocketParser", "YisouSpider", "um-LN", "ToutiaoSpider", "MuckRack", "Jamie's Spider", "AHC/", "NetcraftSurveyAgent", "Laserlikebot", "Apache-HttpClient", "AppEngine-Google", "Jetty", "Upflow", "Thinklab", "Traackr\\.com", "Twurly", "Mastodon", "http_get", "DnyzBot", "botify", "007ac9 Crawler", "BehloolBot", "BrandVerity", "check_http", "BDCbot", "ZumBot", "EZID", "ICC-Crawler", "ArchiveBot", "^LCC ", "filterdb\\.iss\\.net/crawler", "BLP_bbot", "BomboraBot", "Buck/", "Companybook-Crawler", "Genieo", "magpie-crawler", "MeltwaterNews", "Moreover", "newspaper/", "ScoutJet", "(^| )sentry/", "StorygizeBot", "UptimeRobot", "OutclicksBot", "seoscanners", "Hatena", "Google Web Preview", "MauiBot", "AlphaBot", "SBL-BOT", "IAS crawler", "adscanner", "Netvibes", "acapbot", "Baidu-YunGuanCe", "bitlybot", "blogmuraBot", "Bot\\.AraTurka\\.com", "bot-pge\\.chlooe\\.com", "BoxcarBot", "BTWebClient", "ContextAd Bot", "Digincore bot", "Disqus", "Feedly", "Fetch/", "Fever", "Flamingo_SearchEngine", "FlipboardProxy", "g2reader-bot", "imrbot", "K7MLWCBot", "Kemvibot", "Landau-Media-Spider", "linkapediabot", "vkShare", "Siteimprove\\.com", "BLEXBot/", "DareBoost", "ZuperlistBot/", "Miniflux/", "Feedspotbot/", "Diffbot/", "SEOkicks", "tracemyfile", "Nimbostratus-Bot", "Bytespider", "BTTAgent", "OnCrawl"]), ft;
}
var dt, yr;
function xi() {
  if (yr) return dt;
  yr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = Vt(), _ = Ei(), d = he(), u = "_constructorio_is_human", g = ["scroll", "resize", "touchmove", "mouseover", "mousemove", "keydown", "keypress", "keyup", "focus"], a = /* @__PURE__ */ (function() {
    function k() {
      var E = this;
      (0, s.default)(this, k), this.hasPerformedHumanEvent = this.getIsHumanFromSessionStorage();
      var S = function C() {
        E.hasPerformedHumanEvent = !0, v.session.set(u, !0), g.forEach(function(x) {
          d.removeEventListener(x, C, !0);
        });
      };
      this.hasPerformedHumanEvent || g.forEach(function(C) {
        d.addEventListener(C, S, !0);
      });
    }
    return (0, p.default)(k, [{
      key: "getIsHumanFromSessionStorage",
      value: function() {
        return !!v.session.get(u) || !1;
      }
      // Return boolean indicating if user is a bot
      // ...if it has a bot-like useragent
      // ...or uses webdriver
      // ...or has not performed a human event
    }, {
      key: "isBot",
      value: function() {
        var S = d.getNavigator(), C = S.userAgent, x = S.webdriver, R = new RegExp("(".concat(_.join("|"), ")"));
        return !!(C.match(R) || x || !this.getIsHumanFromSessionStorage());
      }
    }]), k;
  })();
  return dt = a, dt;
}
var vt, wr;
function Ci() {
  if (wr) return vt;
  wr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = Vt(), _ = xi(), d = he(), u = he(), g = u.obfuscatePiiRequest, a = "_constructorio_requests", k = 18e4, E = /* @__PURE__ */ (function() {
    function S(C, x) {
      var R = this;
      (0, s.default)(this, S), this.options = C, this.eventemitter = x, this.humanity = new _(), this.requestPending = !1, this.pageUnloading = !1, this.sendTrackingEvents = !!(C && C.sendTrackingEvents === !0), d.addEventListener("visibilitychange", function() {
        document.visibilityState === "hidden" ? R.pageUnloading = !0 : document.visibilityState === "visible" && R.pageUnloading === !0 && (R.pageUnloading = !1, R.sendTrackingEvents && R.send());
      }), this.sendTrackingEvents && this.send();
    }
    return (0, p.default)(S, [{
      key: "queue",
      value: function(x) {
        var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET", w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, e = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        if (this.sendTrackingEvents && (!d.canUseDOM() || !this.humanity.isBot())) {
          var t = S.get(), y = g(x);
          t.push({
            url: y,
            method: R,
            body: w,
            networkParameters: e
          }), S.set(t);
        }
      }
      // Read from queue and send events to server
    }, {
      key: "sendEvents",
      value: function() {
        var x = this, R = this.options.fetch, w = S.get();
        if (
          // Consider user "human" if no DOM context is available
          (!d.canUseDOM() || !this.humanity.isBot()) && !this.requestPending && !this.pageUnloading && w.length
        ) {
          var e, t = w.shift(), y = t, n = y.networkParameters, f, q = this;
          if (S.set(w), n && typeof AbortController == "function") {
            var l = new AbortController();
            f = l.signal, d.applyNetworkTimeout(this.options, n, l);
          }
          if (typeof t == "string" && (t = {
            url: t,
            method: "GET"
          }), t.url) {
            var o = t.url.match(/\?.*_dt=([^&]+)/), r = parseInt(o && o[1], 10), h = +/* @__PURE__ */ new Date();
            if (r && Number.isInteger(r) && h - r > k) {
              this.sendTrackingEvents = !1, S.remove();
              return;
            }
          }
          t.method === "GET" && (e = R(t.url, {
            signal: f
          })), t.method === "POST" && (e = R(t.url, {
            method: t.method,
            body: JSON.stringify(t.body),
            mode: "cors",
            headers: {
              "Content-Type": "text/plain"
            },
            signal: f
          })), e && (this.requestPending = !0, e.then(function(c) {
            c.ok ? (q.eventemitter && q.eventemitter.emit("success", {
              url: t.url,
              method: t.method,
              message: "ok"
            }), x.requestPending = !1, x.send()) : c.json().then(function(b) {
              q.eventemitter && q.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: b && b.message
              }), x.requestPending = !1, x.send();
            }).catch(function(b) {
              q.eventemitter && q.eventemitter.emit("error", {
                url: t.url,
                method: t.method,
                message: b.type
              }), x.requestPending = !1, x.send();
            });
          }).catch(function(c) {
            q.eventemitter && q.eventemitter.emit("error", {
              url: t.url,
              method: t.method,
              message: c && c.toString && c.toString()
            }), x.requestPending = !1, x.send();
          }));
        }
      }
      // Read from queue and send requests to server
    }, {
      key: "send",
      value: function() {
        this.sendTrackingEvents && (this.options && this.options.trackingSendDelay === 0 ? this.sendEvents() : setTimeout(this.sendEvents.bind(this), this.options && this.options.trackingSendDelay || 250));
      }
      // Return current request queue
    }], [{
      key: "get",
      value: function() {
        return v.local.get(a) || [];
      }
      // Update current request queue
    }, {
      key: "set",
      value: function(x) {
        !x || Array.isArray(x) && x.length === 0 ? S.remove() : v.local.set(a, x);
        var R = S.get();
        Array.isArray(R) && R.length !== x.length && (this.sendTrackingEvents = !1, S.remove());
      }
      // Remove current request queue key
    }, {
      key: "remove",
      value: function() {
        v.local.remove(a);
      }
    }]), S;
  })();
  return vt = E, vt;
}
var ht, br;
function Ai() {
  if (br) return ht;
  br = 1;
  var i = fe(), s = i(Ee()), p = i(Ve()), v = i(ge()), _ = i(_e());
  function d(R, w) {
    var e = Object.keys(R);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(R);
      w && (t = t.filter(function(y) {
        return Object.getOwnPropertyDescriptor(R, y).enumerable;
      })), e.push.apply(e, t);
    }
    return e;
  }
  function u(R) {
    for (var w = 1; w < arguments.length; w++) {
      var e = arguments[w] != null ? arguments[w] : {};
      w % 2 ? d(Object(e), !0).forEach(function(t) {
        (0, p.default)(R, t, e[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(R, Object.getOwnPropertyDescriptors(e)) : d(Object(e)).forEach(function(t) {
        Object.defineProperty(R, t, Object.getOwnPropertyDescriptor(e, t));
      });
    }
    return R;
  }
  var g = Ri(), a = he(), k = Ci(), E = 2048;
  function S(R, w) {
    var e = w.apiKey, t = w.version, y = w.sessionId, n = w.clientId, f = w.userId, q = w.segments, l = w.testCells, o = w.requestMethod, r = w.beaconMode, h = a.getWindowLocation(), c = h.host, b = h.pathname, m = h.search, A = w.sendReferrerWithTrackingEvents !== !1, O = Object.assign(R);
    if (t && (O.c = t), n && (O.i = n), y && (O.s = y), f && (O.ui = String(f)), q && q.length && (O.us = q), e && (O.key = e), l && Object.keys(l).forEach(function(I) {
      O["ef-".concat(I)] = l[I];
    }), r && o && o.match(/POST/i) && (O.beacon = !0), A && c && (O.origin_referrer = c, b && (O.origin_referrer += b), m))
      try {
        var U = [], N = new URLSearchParams(m);
        N.forEach(function(I, L) {
          L.match(/utm_/) && U.push("".concat(L, "=").concat(I));
        }), U.length && (O.origin_referrer += "?".concat(U.join("&")));
      } catch {
      }
    return O._dt = Date.now(), O = a.cleanParams(O), O;
  }
  function C(R, w) {
    return a.stringify(S(R, w));
  }
  var x = /* @__PURE__ */ (function() {
    function R(w) {
      (0, v.default)(this, R), this.options = w || {}, this.eventemitter = new g(), this.requests = new k(w, this.eventemitter);
    }
    return (0, _.default)(R, [{
      key: "trackSessionStartV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/v2/behavioral_action/session_start?");
        return this.requests.queue("".concat(t).concat(C({}, this.options)), "POST", void 0, e), this.requests.send(), !0;
      }
      /**
       * Send session start event to API
       *
       * @function trackSessionStart
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.trackSessionStart();
       */
    }, {
      key: "trackSessionStart",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), y = {
          action: "session_start"
        };
        return this.requests.queue("".concat(t).concat(C(y, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       * @private
       * @function trackInputFocusV2
       * @param {string} userInput - The current autocomplete search query
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocusV2("text");
       */
    }, {
      key: "trackInputFocusV2",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/focus?"), f = {}, q = t.analyticsTags, l = q === void 0 ? null : q;
        l && (f.analytics_tags = l), f.user_input = e;
        var o = "POST", r = S(f, u(u({}, this.options), {}, {
          requestMethod: o
        }));
        return this.requests.queue("".concat(n).concat(C({}, this.options)), o, r, y), this.requests.send(), !0;
      }
      /**
       * Send input focus event to API
       *
       * @function trackInputFocus
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on search input element
       * @example
       * constructorio.tracker.trackInputFocus();
       */
    }, {
      key: "trackInputFocus",
      value: function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = "".concat(this.options.serviceUrl, "/behavior?"), y = {
          action: "focus"
        };
        return this.requests.queue("".concat(t).concat(C(y, this.options)), void 0, void 0, e), this.requests.send(), !0;
      }
      /**
       * Send item detail load event to API
       *
       * @function trackItemDetailLoad
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.url - Current page URL
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User loaded an item detail page
       * @example
       * constructorio.tracker.trackItemDetailLoad(
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         url: 'https://constructor.io/product/KMH876',
       *     },
       * );
       */
    }, {
      key: "trackItemDetailLoad",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/item_detail_load?"), n = {}, f = {}, q = e.item_name, l = e.name, o = e.item_id, r = e.customer_id, h = e.customerId, c = h === void 0 ? r : h, b = e.variation_id, m = e.itemName, A = m === void 0 ? q || l : m, O = e.itemId, U = O === void 0 ? o || c : O, N = e.variationId, I = N === void 0 ? b : N, L = e.url, j = e.analyticsTags;
          A && (f.item_name = A), U && (f.item_id = U), I && (f.variation_id = I), j && (f.analytics_tags = j), L && (f.url = a.truncateString(L, E));
          var D = "".concat(y).concat(C(n, this.options)), P = "POST", F = S(f, u(u({}, this.options), {}, {
            requestMethod: P
          }));
          return this.requests.queue(D, P, F, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send autocomplete select event to API
       * @private
       * @function trackAutocompleteSelectV2
       * @param {string} itemName - Name of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.section] - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.variationId] - Variation id of the selected item
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelectV2(
       *     'T-Shirt',
       *      {
       *          userInput: 'Shirt',
       *          section: 'Products',
       *          tr: 'click',
       *          groupId: '88JU230',
       *          itemId: '12345',
       *          variationId: '12345-A',
       *          slCampaignId: 'Campaign 123',
       *          slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelectV2",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/autocomplete_select?"), f = t.original_query, q = t.originalQuery, l = q === void 0 ? f : q, o = t.user_input, r = t.userInput, h = r === void 0 ? l || o : r, c = t.original_section, b = t.section, m = b === void 0 ? c : b, A = t.tr, O = t.group_id, U = t.groupId, N = U === void 0 ? O : U, I = t.item_id, L = t.itemId, j = L === void 0 ? I : L, D = t.variation_id, P = t.variationId, F = P === void 0 ? D : P, M = t.slCampaignId, K = t.slCampaignOwner, Q = {}, B = {
              user_input: h,
              tr: A,
              group_id: N,
              item_id: j,
              variation_id: F,
              item_name: e,
              section: m
            };
            m && (Q.section = m), M && (B.sl_campaign_id = M), K && (B.sl_campaign_owner = K);
            var G = "".concat(n).concat(C(Q, this.options)), W = "POST", H = S(B, u(u({}, this.options), {}, {
              requestMethod: W
            }));
            return this.requests.queue(G, W, H, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete select event to API
       *
       * @function trackAutocompleteSelect
       * @param {string} term - Term of selected autocomplete item
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} parameters.section - Section the selected item resides within
       * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {string} [parameters.itemId] - Item id of the selected item
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
       * @example
       * constructorio.tracker.trackAutocompleteSelect(
       *     'T-Shirt',
       *      {
       *         originalQuery: 'Shirt',
       *         section: 'Products',
       *         tr: 'click',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *         itemId: '12345',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *      },
       * );
       */
    }, {
      key: "trackAutocompleteSelect",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/select?"), f = {}, q = t.original_query, l = t.originalQuery, o = l === void 0 ? q : l, r = t.section, h = t.original_section, c = t.originalSection, b = c === void 0 ? h : c, m = t.tr, A = t.group_id, O = t.groupId, U = O === void 0 ? A : O, N = t.display_name, I = t.displayName, L = I === void 0 ? N : I, j = t.item_id, D = t.itemId, P = D === void 0 ? j : D, F = t.slCampaignOwner, M = t.slCampaignId;
            return o && (f.original_query = o), m && (f.tr = m), (b || r) && (f.section = b || r), U && (f.group = {
              group_id: U,
              display_name: L
            }), P && (f.item_id = P), M && (f.sl_campaign_id = M), F && (f.sl_campaign_owner = F), this.requests.queue("".concat(n).concat(C(f, this.options)), void 0, void 0, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       * @private
       * @function trackSearchSubmitV2
       * @param {string} searchTerm - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.userInput - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmitV2(
       *     'T-Shirt',
       *     {
       *         userInput: 'Shirt',
       *         groupId: '88JU230',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmitV2",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_submit?"), f = t.original_query, q = t.originalQuery, l = q === void 0 ? f : q, o = t.user_input, r = t.userInput, h = r === void 0 ? l || o : r, c = t.group_id, b = t.groupId, m = b === void 0 ? c : b, A = t.section, O = t.analyticsTags, U = O === void 0 ? null : O, N = {}, I = {
              user_input: h,
              search_term: e,
              section: A
            };
            m && (I.filters = {
              group_id: m
            }), A && (N.section = A), U && (I.analytics_tags = U);
            var L = "".concat(n).concat(C(N, this.options)), j = "POST", D = S(I, u(u({}, this.options), {}, {
              requestMethod: j
            }));
            return this.requests.queue(L, j, D, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send autocomplete search event to API
       *
       * @function trackSearchSubmit
       * @param {string} term - Term of submitted autocomplete event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.originalQuery - The current autocomplete search query
       * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
       * @param {string} [parameters.displayName] - Display name of group of selected item
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a search (pressing enter within input element, or clicking submit element)
       * @example
       * constructorio.tracker.trackSearchSubmit(
       *     'T-Shirt',
       *     {
       *         originalQuery: 'Shirt',
       *         groupId: '88JU230',
       *         displayName: 'apparel',
       *     },
       * );
       */
    }, {
      key: "trackSearchSubmit",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/search?"), f = {}, q = t.original_query, l = t.originalQuery, o = l === void 0 ? q : l, r = t.group_id, h = t.groupId, c = h === void 0 ? r : h, b = t.display_name, m = t.displayName, A = m === void 0 ? b : m, O = t.analyticsTags;
            return o && (f.original_query = o), c && (f.group = {
              group_id: c,
              display_name: A
            }), O && (f.analytics_tags = O), this.requests.queue("".concat(n).concat(C(f, this.options)), void 0, void 0, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send search results loaded event to API
       *
       * @function trackSearchResultsLoaded
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - URL of the search results page
       * @param {object[]} parameters.items - List of product item unique identifiers in search results listing
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Current page of search results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultsLoaded(
       *     'T-Shirt',
       *     {
       *         resultCount: 167,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *         sortOrder: 'ascending'
       *         sortBy: 'price',
       *         resultPage: 3,
       *         resultCount: 20
       *     },
       * );
       */
    }, {
      key: "trackSearchResultsLoaded",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n, f, q, l = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_load?"), o = t.num_results, r = t.numResults, h = r === void 0 ? o : r, c = t.result_count, b = t.customerIds, m = t.customer_ids, A = m === void 0 ? b : m, O = t.itemIds, U = t.item_ids, N = U === void 0 ? O : U, I = t.items, L = I === void 0 ? A || N : I, j = t.result_page, D = t.resultPage, P = D === void 0 ? j : D, F = t.result_id, M = t.resultId, K = M === void 0 ? F : M, Q = t.sort_order, B = t.sortOrder, G = B === void 0 ? Q : B, W = t.sort_by, H = t.sortBy, Y = H === void 0 ? W : H, re = t.selected_filters, V = t.selectedFilters, ae = V === void 0 ? re : V, te = t.url, ne = te === void 0 ? ((n = a.getWindowLocation()) === null || n === void 0 ? void 0 : n.href) || "N/A" : te, ue = t.section, Z = t.analyticsTags, de = t.resultCount, ee = de === void 0 ? (f = (q = h ?? c) !== null && q !== void 0 ? q : L?.length) !== null && f !== void 0 ? f : 0 : de, ye = {}, ve;
            if (L && Array.isArray(L) && L.length !== 0) {
              var we = L.slice(0, 100);
              typeof L[0] == "string" || typeof L[0] == "number" ? ve = we.map(function(xe) {
                return {
                  item_id: String(xe)
                };
              }) : ve = we.map(function(xe) {
                return a.toSnakeCaseKeys(xe, !1);
              });
            }
            ue && (ye.section = ue);
            var Fe = {
              search_term: e,
              result_count: ee,
              items: ve,
              result_page: P,
              result_id: K,
              sort_order: G,
              sort_by: Y,
              selected_filters: ae,
              url: a.truncateString(ne, E),
              section: ue,
              analytics_tags: Z
            }, Me = "".concat(l).concat(C(ye, this.options)), Ue = "POST", Ge = S(Fe, u(u({}, this.options), {}, {
              requestMethod: Ue
            }));
            return this.requests.queue(Me, Ue, Ge, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       * @private
       * @function trackSearchResultClickV2
       * @param {string} searchTerm - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name (Either itemName or itemId is required)
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Number of results in total
       * @param {number} [parameters.resultPage] - Current page of results
       * @param {string} [parameters.resultPositionOnPage] - Position of selected items on page
       * @param {string} [parameters.numResultsPerPage] - Number of results per page
       * @param {object} [parameters.selectedFilters] - Key - Value map of selected filters
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClickV2(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClickV2",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_click?"), f = t.num_results, q = t.customer_id, l = t.item_id, o = t.itemId, r = o === void 0 ? q || l : o, h = t.name, c = t.item_name, b = t.itemName, m = b === void 0 ? h || c : b, A = t.variation_id, O = t.variationId, U = O === void 0 ? A : O, N = t.result_id, I = t.resultId, L = I === void 0 ? N : I, j = t.result_count, D = t.resultCount, P = D === void 0 ? f || j : D, F = t.result_page, M = t.resultPage, K = M === void 0 ? F : M, Q = t.result_position_on_page, B = t.resultPositionOnPage, G = B === void 0 ? Q : B, W = t.num_results_per_page, H = t.numResultsPerPage, Y = H === void 0 ? W : H, re = t.selected_filters, V = t.selectedFilters, ae = V === void 0 ? re : V, te = t.section, ne = t.analyticsTags, ue = t.slCampaignId, Z = t.slCampaignOwner, de = {
              sl_campaign_id: ue,
              sl_campaign_owner: Z,
              item_name: m,
              item_id: r,
              variation_id: U,
              result_id: L,
              result_count: P,
              result_page: K,
              result_position_on_page: G,
              num_results_per_page: Y,
              selected_filters: ae,
              section: te,
              search_term: e,
              analytics_tags: ne
            }, ee = {};
            te && (ee.section = te);
            var ye = "".concat(n).concat(C(ee, this.options)), ve = "POST", we = S(de, u(u({}, this.options), {}, {
              requestMethod: ve
            }));
            return this.requests.queue(ye, ve, we, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send click through event to API
       *
       * @function trackSearchResultClick
       * @param {string} term - Search results query term
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemName - Product item name
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
       * @param {string} [parameters.itemIsConvertible] - Whether or not an item is available for a conversion
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a search product listing page
       * @example
       * constructorio.tracker.trackSearchResultClick(
       *     'T-Shirt',
       *     {
       *         itemName: 'Red T-Shirt',
       *         itemId: 'KMH876',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackSearchResultClick",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (e && typeof e == "string") {
          if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
            var n = "".concat(this.options.serviceUrl, "/autocomplete/").concat(a.encodeURIComponentRFC3986(a.trimNonBreakingSpaces(e)), "/click_through?"), f = {}, q = t.item_name, l = t.name, o = t.itemName, r = o === void 0 ? q || l : o, h = t.item_id, c = t.itemId, b = c === void 0 ? h : c, m = t.customer_id, A = t.customerId, O = A === void 0 ? m || b : A, U = t.variation_id, N = t.variationId, I = N === void 0 ? U : N, L = t.result_id, j = t.resultId, D = j === void 0 ? L : j, P = t.item_is_convertible, F = t.itemIsConvertible, M = F === void 0 ? P : F, K = t.section, Q = t.analyticsTags, B = t.slCampaignOwner, G = t.slCampaignId;
            return r && (f.name = r), O && (f.customer_id = O), I && (f.variation_id = I), D && (f.result_id = D), typeof M == "boolean" && (f.item_is_convertible = M), K && (f.section = K), Q && (f.analytics_tags = Q), G && (f.sl_campaign_id = G), B && (f.sl_campaign_owner = B), this.requests.queue("".concat(n).concat(C(f, this.options)), void 0, void 0, y), this.requests.send(), !0;
          }
          return this.requests.send(), new Error("parameters are required of type object");
        }
        return this.requests.send(), new Error("term is a required parameter of type string");
      }
      /**
       * Send conversion event to API
       *
       * @function trackConversion
       * @param {string} [term] - Search results query term that led to conversion event
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {number} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User performed an action indicating interest in an item (add to cart, add to wishlist, etc.)
       * @see https://docs.constructor.com/docs/integrating-with-constructor-behavioral-tracking-data-driven-event-tracking
       * @example
       * constructorio.tracker.trackConversion(
       *     'T-Shirt',
       *     {
       *         itemId: 'KMH876',
       *         revenue: 12.00,
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *         type: 'like',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackConversion",
      value: function(e, t) {
        var y = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        if (t && (0, s.default)(t) === "object" && !Array.isArray(t)) {
          var n = e || "TERM_UNKNOWN", f = "".concat(this.options.serviceUrl, "/v2/behavioral_action/conversion?"), q = {}, l = {}, o = t.name, r = t.item_name, h = t.itemName, c = h === void 0 ? r || o : h, b = t.customer_id, m = t.customerId, A = m === void 0 ? b : m, O = t.item_id, U = t.itemId, N = U === void 0 ? O || A : U, I = t.variation_id, L = t.variationId, j = L === void 0 ? I : L, D = t.revenue, P = t.section, F = P === void 0 ? "Products" : P, M = t.display_name, K = t.displayName, Q = K === void 0 ? M : K, B = t.type, G = t.is_custom_type, W = t.isCustomType, H = W === void 0 ? G : W;
          N && (l.item_id = N), c && (l.item_name = c), j && (l.variation_id = j), (D || D === 0) && (l.revenue = D.toString()), F && (q.section = F, l.section = F), n && (l.search_term = n), B && (l.type = B), H && (l.is_custom_type = H), Q && (l.display_name = Q);
          var Y = "".concat(f).concat(C(q, this.options)), re = "POST", V = S(l, u(u({}, this.options), {}, {
            requestMethod: re
          }));
          return this.requests.queue(Y, re, V, y), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send purchase event to API
       *
       * @function trackPurchase
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {Array.<{itemId: string | undefined,
       * variationId: string | undefined,
       * itemName: string | undefined,
       * count: number | undefined,
       * price: number | undefined}>} parameters.items - List of product item objects
       * @param {number} parameters.revenue - The subtotal (excluding taxes, shipping, etc.) of the entire order
       * @param {string} [parameters.orderId] - Unique order identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User completed an order (usually fired on order confirmation page)
       * @example
       * constructorio.tracker.trackPurchase(
       *     {
       *         items: [{ itemId: 'KMH876', price: 1, count: 1}, { itemId: 'KMH140', price: 1, count: 1s }],
       *         revenue: 12.00,
       *         orderId: 'OUNXBG2HMA',
       *         section: 'Products',
       *     },
       * );
       */
    }, {
      key: "trackPurchase",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/purchase?"), n = {}, f = {}, q = e.items, l = e.revenue, o = e.order_id, r = e.orderId, h = r === void 0 ? o : r, c = e.section, b = e.analyticsTags, m = this.options.apiKey;
          if (h) {
            if (a.hasOrderIdRecord({
              orderId: h,
              apiKey: m
            }))
              return !1;
            a.addOrderIdRecord({
              orderId: h,
              apiKey: m
            }), f.order_id = h;
          }
          q && Array.isArray(q) && (f.items = q.slice(0, 100).map(function(N) {
            return a.toSnakeCaseKeys(N, !1);
          })), (l || l === 0) && (f.revenue = l), c ? n.section = c : n.section = "Products", b && (f.analytics_tags = b);
          var A = "".concat(y).concat(C(n, this.options)), O = "POST", U = S(f, u(u({}, this.options), {}, {
            requestMethod: O
          }));
          return this.requests.queue(A, O, U, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation view event to API
       *
       * @function trackRecommendationView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.podId - Pod identifier
       * @param {number} parameters.numResultsViewed - Number of results viewed
       * @param {object[]} [parameters.items] - List of Product Item Objects
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {string} [parameters.section="Products"] - Results section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a set of recommendations
       * @example
       * constructorio.tracker.trackRecommendationView(
       *     {
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         podId: '019927c2-f955-4020',
       *         numResultsViewed: 3,
       *     },
       * );
       */
    }, {
      key: "trackRecommendationView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_view?"), n = {}, f = e.result_count, q = e.result_page, l = e.resultPage, o = l === void 0 ? q : l, r = e.result_id, h = e.resultId, c = h === void 0 ? r : h, b = e.section, m = e.url, A = e.pod_id, O = e.podId, U = O === void 0 ? A : O, N = e.num_results_viewed, I = e.numResultsViewed, L = I === void 0 ? N : I, j = e.items, D = e.analyticsTags, P = e.seedItemIds, F = e.resultCount, M = F === void 0 ? f || j?.length || 0 : F;
          a.isNil(M) || (n.result_count = M), a.isNil(o) || (n.result_page = o), c && (n.result_id = c), b ? n.section = b : n.section = "Products", m && (n.url = a.truncateString(m, E)), U && (n.pod_id = U), a.isNil(L) || (n.num_results_viewed = L), j && Array.isArray(j) && (n.items = j.slice(0, 100).map(function(G) {
            return a.toSnakeCaseKeys(G, !1);
          })), D && (n.analytics_tags = D), typeof P == "number" ? n.seed_item_ids = [String(P)] : P != null && P.length && typeof P == "string" ? n.seed_item_ids = [P] : P != null && P.length && Array.isArray(P) && (n.seed_item_ids = P);
          var K = "".concat(y).concat(C({}, this.options)), Q = "POST", B = S(n, u(u({}, this.options), {}, {
            requestMethod: Q
          }));
          return this.requests.queue(K, Q, B, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send recommendation click event to API
       *
       * @function trackRecommendationClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.podId - Pod identifier
       * @param {string} parameters.strategyId - Strategy identifier
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of result on page
       * @param {number} [parameters.numResultsPerPage] - Number of results on page
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
       * @returns {(true|Error)}
       * @description User clicked an item that appeared within a list of recommended results
       * @example
       * constructorio.tracker.trackRecommendationClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         podId: '019927c2-f955-4020',
       *         strategyId: 'complimentary',
       *         itemId: 'KMH876',
       *         itemName: 'Socks',
       *         seedItemIds: ['item-123', 'item-456'],
       *     },
       * );
       */
    }, {
      key: "trackRecommendationClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_click?"), n = {}, f = e.variation_id, q = e.variationId, l = q === void 0 ? f : q, o = e.section, r = o === void 0 ? "Products" : o, h = e.result_id, c = e.resultId, b = c === void 0 ? h : c, m = e.result_count, A = e.resultCount, O = A === void 0 ? m : A, U = e.result_page, N = e.resultPage, I = N === void 0 ? U : N, L = e.result_position_on_page, j = e.resultPositionOnPage, D = j === void 0 ? L : j, P = e.num_results_per_page, F = e.numResultsPerPage, M = F === void 0 ? P : F, K = e.pod_id, Q = e.podId, B = Q === void 0 ? K : Q, G = e.strategy_id, W = e.strategyId, H = W === void 0 ? G : W, Y = e.item_id, re = e.itemId, V = re === void 0 ? Y : re, ae = e.item_name, te = e.itemName, ne = te === void 0 ? ae : te, ue = e.analyticsTags, Z = e.slCampaignId, de = e.slCampaignOwner, ee = e.seedItemIds;
          l && (n.variation_id = l), r && (n.section = r), b && (n.result_id = b), a.isNil(O) || (n.result_count = O), a.isNil(I) || (n.result_page = I), a.isNil(D) || (n.result_position_on_page = D), a.isNil(M) || (n.num_results_per_page = M), B && (n.pod_id = B), H && (n.strategy_id = H), V && (n.item_id = V), ne && (n.item_name = ne), ue && (n.analytics_tags = ue), Z && (n.sl_campaign_id = Z), de && (n.sl_campaign_owner = de), typeof ee == "number" ? n.seed_item_ids = [String(ee)] : ee != null && ee.length && typeof ee == "string" ? n.seed_item_ids = [ee] : ee != null && ee.length && Array.isArray(ee) && (n.seed_item_ids = ee);
          var ye = "".concat(y).concat(C({}, this.options)), ve = "POST", we = S(n, u(u({}, this.options), {}, {
            requestMethod: ve
          }));
          return this.requests.queue(ye, ve, we, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse results loaded event to API
       *
       * @function trackBrowseResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.url - Current page URL
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section="Products"] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultsLoaded(
       *     {
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
       *         url: 'https://demo.constructor.io/sandbox/farmstand',
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y, n = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_load?"), f = {}, q = e.section, l = q === void 0 ? "Products" : q, o = e.result_count, r = e.result_page, h = e.resultPage, c = h === void 0 ? r : h, b = e.result_id, m = e.resultId, A = m === void 0 ? b : m, O = e.selected_filters, U = e.selectedFilters, N = U === void 0 ? O : U, I = e.url, L = e.sort_order, j = e.sortOrder, D = j === void 0 ? L : j, P = e.sort_by, F = e.sortBy, M = F === void 0 ? P : F, K = e.filter_name, Q = e.filterName, B = Q === void 0 ? K : Q, G = e.filter_value, W = e.filterValue, H = W === void 0 ? G : W, Y = e.items, re = e.analyticsTags, V = e.resultCount, ae = V === void 0 ? (y = o ?? Y?.length) !== null && y !== void 0 ? y : 0 : V;
          l && (f.section = l), a.isNil(ae) || (f.result_count = ae), a.isNil(c) || (f.result_page = c), A && (f.result_id = A), N && (f.selected_filters = N), I && (f.url = a.truncateString(I, E)), D && (f.sort_order = D), M && (f.sort_by = M), B && (f.filter_name = B), H && (f.filter_value = H), Y && Array.isArray(Y) && (f.items = Y.slice(0, 100).map(function(Z) {
            return a.toSnakeCaseKeys(Z, !1);
          })), re && (f.analytics_tags = re);
          var te = "".concat(n).concat(C({}, this.options)), ne = "POST", ue = S(f, u(u({}, this.options), {}, {
            requestMethod: ne
          }));
          return this.requests.queue(te, ne, ue, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse result click event to API
       *
       * @function trackBrowseResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section="Products"] - Index section
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - Page number of results
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [parameters.selectedFilters] -  Selected filters
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
       * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         resultCount: 22,
       *         resultPage: 2,
       *         resultPositionOnPage: 2,
       *         numResultsPerPage: 12,
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         itemId: 'KMH876',
       *         slCampaignId: 'Campaign 123',
       *         slCampaignOwner: 'Store 123',
       *     },
       * );
       */
    }, {
      key: "trackBrowseResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_click?"), n = {}, f = e.section, q = f === void 0 ? "Products" : f, l = e.variation_id, o = e.variationId, r = o === void 0 ? l : o, h = e.result_id, c = e.resultId, b = c === void 0 ? h : c, m = e.result_count, A = e.resultCount, O = A === void 0 ? m : A, U = e.result_page, N = e.resultPage, I = N === void 0 ? U : N, L = e.result_position_on_page, j = e.resultPositionOnPage, D = j === void 0 ? L : j, P = e.num_results_per_page, F = e.numResultsPerPage, M = F === void 0 ? P : F, K = e.selected_filters, Q = e.selectedFilters, B = Q === void 0 ? K : Q, G = e.filter_name, W = e.filterName, H = W === void 0 ? G : W, Y = e.filter_value, re = e.filterValue, V = re === void 0 ? Y : re, ae = e.customer_id, te = e.customerId, ne = te === void 0 ? ae : te, ue = e.item_id, Z = e.itemId, de = Z === void 0 ? ne || ue : Z, ee = e.item_name, ye = e.name, ve = e.itemName, we = ve === void 0 ? ee || ye : ve, Fe = e.analyticsTags, Me = e.slCampaignId, Ue = e.slCampaignOwner;
          q && (n.section = q), r && (n.variation_id = r), b && (n.result_id = b), a.isNil(O) || (n.result_count = O), a.isNil(I) || (n.result_page = I), a.isNil(D) || (n.result_position_on_page = D), a.isNil(M) || (n.num_results_per_page = M), B && (n.selected_filters = B), H && (n.filter_name = H), V && (n.filter_value = V), de && (n.item_id = de), we && (n.item_name = we), Fe && (n.analytics_tags = Fe), Me && (n.sl_campaign_id = Me), Ue && (n.sl_campaign_owner = Ue);
          var Ge = "".concat(y).concat(C({}, this.options)), xe = "POST", Hr = S(n, u(u({}, this.options), {}, {
            requestMethod: xe
          }));
          return this.requests.queue(Ge, xe, Hr, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send browse redirect event to API
       * @private
       * @function trackBrowseRedirect
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.searchTerm - The search query that caused redirect
       * @param {string} parameters.filterName - Filter name
       * @param {string} parameters.filterValue - Filter value
       * @param {string} [parameters.userInput] - The text that a user had typed at the moment when submitting search request
       * @param {string} [parameters.redirectToUrl] - URL of the  page to which user is redirected
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.selectedFilters] - Selected filters
       * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
       * @param {string} [parameters.sortBy] - Sorting method
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User got redirected to a browse product listing page
       * @example
       * constructorio.tracker.trackBrowseRedirect(
       *     {
       *         searchTerm: "books",
       *         filterName: 'brand',
       *         filterValue: 'XYZ',
       *         redirectToUrl: 'https://demo.constructor.io/books',
       *         selectedFilters: { brand: ['foo'], color: ['black'] },
       *         sortOrder: 'ascending',
       *         sortBy: 'price',
       *     },
       * );
       */
    }, {
      key: "trackBrowseRedirect",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_redirect?"), n = {}, f = e.searchTerm, q = e.userInput, l = e.section, o = l === void 0 ? "Products" : l, r = e.selectedFilters, h = e.redirectToUrl, c = e.sortOrder, b = e.sortBy, m = e.filterName, A = e.filterValue, O = e.analyticsTags;
          f && (n.search_term = f), q && (n.user_input = q), h && (n.redirect_to_url = h), o && (n.section = o), r && (n.selected_filters = r), c && (n.sort_order = c), b && (n.sort_by = b), m && (n.filter_name = m), A && (n.filter_value = A), O && (n.analytics_tags = O);
          var U = "".concat(y).concat(C({}, this.options)), N = "POST", I = S(n, u(u({}, this.options), {}, {
            requestMethod: N
          }));
          return this.requests.queue(U, N, I, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send generic result click event to API
       *
       * @function trackGenericResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.section="Products"] - Index section
       * @param {object} [parameters.analyticsTags] - Pass additional analytics data
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared outside of the scope of search / browse / recommendations
       * @example
       * constructorio.tracker.trackGenericResultClick(
       *     {
       *         itemId: 'KMH876',
       *         itemName: 'Red T-Shirt',
       *         variationId: 'KMH879-7632',
       *     },
       * );
       */
    }, {
      key: "trackGenericResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if ((0, s.default)(e) === "object") {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/result_click?"), n = {}, f = e.item_id, q = e.itemId, l = q === void 0 ? f : q, o = e.item_name, r = e.itemName, h = r === void 0 ? o : r, c = e.variation_id, b = e.variationId, m = b === void 0 ? c : b, A = e.section, O = A === void 0 ? "Products" : A, U = e.analyticsTags;
          if (l) {
            n.section = O, n.item_id = l, h && (n.item_name = h), m && (n.variation_id = m), U && (n.analytics_tags = U);
            var N = "".concat(y).concat(C({}, this.options)), I = "POST", L = S(n, u(u({}, this.options), {}, {
              requestMethod: I
            }));
            return this.requests.queue(N, I, L, t), this.requests.send(), !0;
          }
        }
        return this.requests.send(), new Error('A parameters object with an "itemId" property is required.');
      }
      /**
       * Send quiz results loaded event to API
       *
       * @function trackQuizResultsLoaded
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} parameters.url - Current page url
       * @param {object[]} parameters.items - List of product item objects
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultsLoaded(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         url: 'www.example.com',
       *         resultCount: 167,
       *         items: [{ itemId: 'KMH876', itemName: 'coffee' }, { itemId: 'KMH140', variationId: '123' }],
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultsLoaded",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_load?"), n = e.quiz_id, f = e.quizId, q = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, h = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? h : c, m = e.url, A = e.section, O = A === void 0 ? "Products" : A, U = e.result_count, N = e.resultCount, I = N === void 0 ? U : N, L = e.result_id, j = e.resultId, D = j === void 0 ? L : j, P = e.result_page, F = e.resultPage, M = F === void 0 ? P : F, K = e.items, Q = {}, B = {};
          if (K && Array.isArray(K) && (B.items = K.slice(0, 100).map(function(Y) {
            return a.toSnakeCaseKeys(Y, !1);
          })), typeof q != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof m != "string")
            return new Error('"url" is a required parameter of type string');
          if (B.quiz_id = q, B.quiz_version_id = r, B.quiz_session_id = b, B.url = a.truncateString(m, E), !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"section" must be a string');
            Q.section = O, B.section = O;
          }
          if (!a.isNil(I)) {
            if (typeof I != "number")
              return new Error('"resultCount" must be a number');
            B.result_count = I;
          }
          if (!a.isNil(D)) {
            if (typeof D != "string")
              return new Error('"resultId" must be a string');
            B.result_id = D;
          }
          if (!a.isNil(M)) {
            if (typeof M != "number")
              return new Error('"resultPage" must be a number');
            B.result_page = M;
          }
          var G = "".concat(y).concat(C(Q, this.options)), W = "POST", H = S(B, u(u({}, this.options), {}, {
            requestMethod: W
          }));
          return this.requests.queue(G, W, H, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz result click event to API
       *
       * @function trackQuizResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product variation unique identifier
       * @param {string} [parameters.section='Products'] - Index section
       * @param {number} [parameters.resultCount] - Total number of results
       * @param {number} [parameters.resultPage] - The page of the results
       * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
       * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
       * @param {number} [parameters.numResultsPerPage] - Number of results shown
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizResultClick(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '123',
       *         itemId: '123',
       *         itemName: 'espresso'
       *         variationId: '733431',
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_click?"), n = e.quiz_id, f = e.quizId, q = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, h = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? h : c, m = e.item_id, A = e.itemId, O = A === void 0 ? m : A, U = e.item_name, N = e.itemName, I = N === void 0 ? U : N, L = e.result_count, j = e.resultCount, D = j === void 0 ? L : j, P = e.result_id, F = e.resultId, M = F === void 0 ? P : F, K = e.result_page, Q = e.resultPage, B = Q === void 0 ? K : Q, G = e.num_results_per_page, W = e.numResultsPerPage, H = W === void 0 ? G : W, Y = e.result_position_on_page, re = e.resultPositionOnPage, V = re === void 0 ? Y : re, ae = e.section, te = ae === void 0 ? "Products" : ae, ne = e.variationId, ue = {}, Z = {};
          if (typeof q != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof I != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (Z.quiz_id = q, Z.quiz_version_id = r, Z.quiz_session_id = b, !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            Z.item_id = O;
          }
          if (!a.isNil(I)) {
            if (typeof I != "string")
              return new Error('"itemName" must be a string');
            Z.item_name = I;
          }
          if (!a.isNil(ne)) {
            if (typeof ne != "string")
              return new Error('"variationId" must be a string');
            Z.variation_id = ne;
          }
          if (!a.isNil(te)) {
            if (typeof te != "string")
              return new Error('"section" must be a string');
            ue.section = te;
          }
          if (!a.isNil(D)) {
            if (typeof D != "number")
              return new Error('"resultCount" must be a number');
            Z.result_count = D;
          }
          if (!a.isNil(M)) {
            if (typeof M != "string")
              return new Error('"resultId" must be a string');
            Z.result_id = M;
          }
          if (!a.isNil(B)) {
            if (typeof B != "number")
              return new Error('"resultPage" must be a number');
            Z.result_page = B;
          }
          if (!a.isNil(H)) {
            if (typeof H != "number")
              return new Error('"numResultsPerPage" must be a number');
            Z.num_results_per_page = H;
          }
          if (!a.isNil(V)) {
            if (typeof V != "number")
              return new Error('"resultPositionOnPage" must be a number');
            Z.result_position_on_page = V;
          }
          var de = "".concat(y).concat(C(ue, this.options)), ee = "POST", ye = S(Z, u(u({}, this.options), {}, {
            requestMethod: ee
          }));
          return this.requests.queue(de, ee, ye, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send quiz conversion event to API
       *
       * @function trackQuizConversion
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.quizId - Quiz identifier
       * @param {string} parameters.quizVersionId - Quiz version identifier
       * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
       * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
       * @param {string} [parameters.itemName] - Product item name
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
       * @param {string} [parameters.section='Products'] - Index section
       * @param {string} [parameters.type='add_to_cart'] - Conversion type
       * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
       * @param {string} [parameters.displayName] - Display name for the custom conversion type
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a quiz results page
       * @example
       * constructorio.tracker.trackQuizConversion(
       *     {
       *         quizId: 'coffee-quiz',
       *         quizVersionId: '1231244',
       *         quizSessionId: '3123',
       *         itemName: 'espresso',
       *         variationId: '167',
       *         type: 'add_to_cart',
       *         revenue: '1.0'
       *     },
       * );
       */
      // eslint-disable-next-line complexity
    }, {
      key: "trackQuizConversion",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_conversion?"), n = e.quiz_id, f = e.quizId, q = f === void 0 ? n : f, l = e.quiz_version_id, o = e.quizVersionId, r = o === void 0 ? l : o, h = e.quiz_session_id, c = e.quizSessionId, b = c === void 0 ? h : c, m = e.item_id, A = e.itemId, O = A === void 0 ? m : A, U = e.item_name, N = e.itemName, I = N === void 0 ? U : N, L = e.variation_id, j = e.variationId, D = j === void 0 ? L : j, P = e.revenue, F = e.section, M = F === void 0 ? "Products" : F, K = e.type, Q = e.is_custom_type, B = e.isCustomType, G = B === void 0 ? Q : B, W = e.display_name, H = e.displayName, Y = H === void 0 ? W : H, re = {}, V = {};
          if (typeof q != "string")
            return new Error('"quizId" is a required parameter of type string');
          if (typeof r != "string")
            return new Error('"quizVersionId" is a required parameter of type string');
          if (typeof b != "string")
            return new Error('"quizSessionId" is a required parameter of type string');
          if (typeof O != "string" && typeof I != "string")
            return new Error('"itemId" or "itemName" is a required parameter of type string');
          if (V.quiz_id = q, V.quiz_version_id = r, V.quiz_session_id = b, !a.isNil(O)) {
            if (typeof O != "string")
              return new Error('"itemId" must be a string');
            V.item_id = O;
          }
          if (!a.isNil(I)) {
            if (typeof I != "string")
              return new Error('"itemName" must be a string');
            V.item_name = I;
          }
          if (!a.isNil(D)) {
            if (typeof D != "string")
              return new Error('"variationId" must be a string');
            V.variation_id = D;
          }
          if (!a.isNil(P)) {
            if (typeof P != "string")
              return new Error('"revenue" must be a string');
            V.revenue = P;
          }
          if (!a.isNil(M)) {
            if (typeof M != "string")
              return new Error('"section" must be a string');
            V.section = M;
          }
          if (!a.isNil(K)) {
            if (typeof K != "string")
              return new Error('"type" must be a string');
            V.type = K;
          }
          if (!a.isNil(G)) {
            if (typeof G != "boolean")
              return new Error('"isCustomType" must be a boolean');
            V.is_custom_type = G;
          }
          if (!a.isNil(Y)) {
            if (typeof Y != "string")
              return new Error('"displayName" must be a string');
            V.display_name = Y;
          }
          var ae = "".concat(y).concat(C(re, this.options)), te = "POST", ne = S(V, u(u({}, this.options), {}, {
            requestMethod: te
          }));
          return this.requests.queue(ae, te, ne, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @function trackAgentSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an agent search
       *   (pressing enter within agent input element, or clicking agent submit element)
       * @example
       * constructorio.tracker.trackAgentSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAgentSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_submit?"), n = e.section, f = e.intent, q = {
            intent: f,
            section: n
          }, l = "".concat(y).concat(C({}, this.options)), o = "POST", r = S(q, u(u({}, this.options), {}, {
            requestMethod: o
          }));
          return this.requests.queue(l, o, r, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load started
       *
       * @function trackAgentResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAgentResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_start?"), n = e.section, f = e.intentResultId, q = e.intent, l = {
            intent_result_id: f,
            intent: q,
            section: n
          }, o = "".concat(y).concat(C({}, this.options)), r = "POST", h = S(l, u(u({}, this.options), {}, {
            requestMethod: r
          }));
          return this.requests.queue(o, r, h, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent results page load finished
       *
       * @function trackAgentResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Agent results page load finished
       * @example
       * constructorio.tracker.trackAgentResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAgentResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_finish?"), n = e.section, f = e.searchResultCount, q = e.intentResultId, l = e.intent, o = {
            intent_result_id: q,
            section: n,
            intent: l,
            search_result_count: f
          }, r = "".concat(y).concat(C({}, this.options)), h = "POST", c = S(o, u(u({}, this.options), {}, {
            requestMethod: h
          }));
          return this.requests.queue(r, h, c, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent result click event to API
       *
       * @function trackAgentResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an agent search result
       * @example
       * constructorio.tracker.trackAgentResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAgentResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_click?"), n = e.section, f = n === void 0 ? "Products" : n, q = e.variationId, l = e.intentResultId, o = e.searchResultId, r = e.itemId, h = e.itemName, c = e.intent, b = {
            section: f,
            variation_id: q,
            intent_result_id: l,
            search_result_id: o,
            item_id: r,
            item_name: h,
            intent: c
          }, m = "".concat(y).concat(C({}, this.options)), A = "POST", O = S(b, u(u({}, this.options), {}, {
            requestMethod: A
          }));
          return this.requests.queue(m, A, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send agent search result view event to API
       *
       * @function trackAgentResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an agent result
       * @example
       * constructorio.tracker.trackAgentResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAgentResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_view?"), n = e.section, f = n === void 0 ? "Products" : n, q = e.items, l = e.numResultsViewed, o = e.intentResultId, r = e.searchResultId, h = e.intent, c = {
            section: f,
            intent_result_id: o,
            search_result_id: r,
            num_results_viewed: l,
            items: q && Array.isArray(q) && q.slice(0, 100).map(function(O) {
              return a.toSnakeCaseKeys(O, !1);
            }),
            intent: h
          }, b = "".concat(y).concat(C({}, this.options)), m = "POST", A = S(c, u(u({}, this.options), {}, {
            requestMethod: m
          }));
          return this.requests.queue(b, m, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters are required of type object");
      }
      /**
       * Send ASA search submitted event
       *
       * @function trackAgentSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted agent search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative agent search result search term
       * @example
       * constructorio.tracker.trackAgentSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAgentSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_submit?"), n = e.section, f = e.intent, q = e.searchTerm, l = e.searchResultId, o = e.intentResultId, r = {
            intent: f,
            section: n,
            search_term: q,
            search_result_id: l,
            intent_result_id: o
          }, h = "".concat(y).concat(C({}, this.options)), c = "POST", b = S(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(h, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send ASA request submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSubmit instead.
       * @function trackAssistantSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an assistant search
       *   (pressing enter within assistant input element, or clicking assistant submit element)
       * @example
       * constructorio.tracker.trackAssistantSubmit(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSubmit(e, t);
      }
      /**
       * Send assistant results page load started
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadStarted instead.
       * @function trackAssistantResultLoadStarted
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load begun (but has not necessarily loaded completely)
       * @example
       * constructorio.tracker.trackAssistantResultLoadStarted(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadStarted",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadStarted(e, t);
      }
      /**
       * Send assistant results page load finished
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultLoadFinished instead.
       * @function trackAssistantResultLoadFinished
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {number} parameters.searchResultCount - Number of search results loaded
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description Assistant results page load finished
       * @example
       * constructorio.tracker.trackAssistantResultLoadFinished(
       *     {
       *         intent: 'show me a recipe for a cookie',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         searchResultCount: 5,
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultLoadFinished",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultLoadFinished(e, t);
      }
      /**
       * Send assistant result click event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultClick instead.
       * @function trackAssistantResultClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {string} parameters.itemId - Product item unique identifier
       * @param {string} parameters.itemName - Product item name
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.variationId] - Product item variation unique identifier
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked a result that appeared within an assistant search result
       * @example
       * constructorio.tracker.trackAssistantResultClick(
       *     {
       *         variationId: 'KMH879-7632',
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         itemId: 'KMH876',
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultClick(e, t);
      }
      /**
       * Send assistant search result view event to API
       *
       * @deprecated This method will be removed in a future version. Use trackAgentResultView instead.
       * @function trackAssistantResultView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - intent of the user
       * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
       * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
       * @param {object[]} [parameters.items] - List of product item objects viewed
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed a search result within an assistant result
       * @example
       * constructorio.tracker.trackAssistantResultView(
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         numResultsViewed: 5,
       *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
       *     },
       * );
       */
    }, {
      key: "trackAssistantResultView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentResultView(e, t);
      }
      /**
       * Send ASA search submitted event
       *
       * @deprecated This method will be removed in a future version. Use trackAgentSearchSubmit instead.
       * @function trackAssistantSearchSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.intent - Intent of user request
       * @param {string} parameters.searchTerm - Term of submitted assistant search event
       * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted an alternative assistant search result search term
       * @example
       * constructorio.tracker.trackAssistantSearchSubmit({
       *     {
       *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
       *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
       *         intent: 'show me a recipe for a cookie',
       *         searchTerm: 'flour',
       *     },
       * );
       */
    }, {
      key: "trackAssistantSearchSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return this.trackAgentSearchSubmit(e, t);
      }
      /**
       * Send product insights agent view events
       *
       * @function trackProductInsightsAgentViews
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {array.<{start: string | undefined,
       * end: string | undefined}>} parameters.viewTimespans - List of timestamp pairs in ISO_8601 format
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentViews({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *     'viewTimespans': [
       *       {
       *         'start': '2025-05-19T14:30:00+02:00',
       *         'end': '2025-05-19T14:30:05+02:00'
       *       },
       *       {
       *         'start': '2025-05-19T14:30:10+02:00',
       *         'end': '2025-05-19T14:30:15+02:00'
       *       }
       *     ]
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentViews",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_views?"), n = e.section, f = e.questions, q = e.itemId, l = e.itemName, o = e.variationId, r = e.viewTimespans, h = {}, c = {
            questions: f,
            item_id: q,
            item_name: l,
            variation_id: o,
            view_timespans: r
          };
          n && (h.section = n);
          var b = "".concat(y).concat(C(h, this.options)), m = "POST", A = S(c, u(u({}, this.options), {}, {
            requestMethod: m
          }));
          return this.requests.queue(b, m, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent view event
       *
       * @function trackProductInsightsAgentView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element appeared in the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'questions': [
       *        { question: 'Why choose this?' },
       *        { question: 'How is this product made?' },
       *        { question: 'What are the dimensions of this product?' }
       *     ],
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_view?"), n = e.section, f = e.questions, q = e.itemId, l = e.itemName, o = e.variationId, r = {}, h = {
            questions: f,
            item_id: q,
            item_name: l,
            variation_id: o
          };
          n && (r.section = n);
          var c = "".concat(y).concat(C(r, this.options)), b = "POST", m = S(h, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, m, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent out of view event
       *
       * @function trackProductInsightsAgentOutOfView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description The product insights agent element disappeared from the visible part of the page
       * @example
       * constructorio.tracker.trackProductInsightsAgentOutOfView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentOutOfView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_out_of_view?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = {}, r = {
            item_id: f,
            item_name: q,
            variation_id: l
          };
          n && (o.section = n);
          var h = "".concat(y).concat(C(o, this.options)), c = "POST", b = S(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(h, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent input focus event
       *
       * @function trackProductInsightsAgentFocus
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User focused on the product insights agent input element
       * @example
       * constructorio.tracker.trackProductInsightsAgentFocus({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentFocus",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_focus?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = {}, r = {
            item_id: f,
            item_name: q,
            variation_id: l
          };
          n && (o.section = n);
          var h = "".concat(y).concat(C(o, this.options)), c = "POST", b = S(r, u(u({}, this.options), {}, {
            requestMethod: c
          }));
          return this.requests.queue(h, c, b, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question click event
       *
       * @function trackProductInsightsAgentQuestionClick
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user clicked on
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User clicked on a question within the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionClick({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionClick",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_click?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = e.question, r = {}, h = {
            item_id: f,
            item_name: q,
            variation_id: l,
            question: o
          };
          n && (r.section = n);
          var c = "".concat(y).concat(C(r, this.options)), b = "POST", m = S(h, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, m, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent question submit event
       *
       * @function trackProductInsightsAgentQuestionSubmit
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User submitted a question to the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentQuestionSubmit({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Tell me some key highlights about this item?'
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentQuestionSubmit",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_submit?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = e.question, r = {}, h = {
            item_id: f,
            item_name: q,
            variation_id: l,
            question: o
          };
          n && (r.section = n);
          var c = "".concat(y).concat(C(r, this.options)), b = "POST", m = S(h, u(u({}, this.options), {}, {
            requestMethod: b
          }));
          return this.requests.queue(c, b, m, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer view event
       *
       * @function trackProductInsightsAgentAnswerView
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.question - Question a user submitted
       * @param {string} parameters.answerText - Answer text of the question
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description User viewed the answer provided by the product insights agent
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerView({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'question': 'Why choose this?',
       *     'answerText': 'This product is awesome!',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerView",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_view?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = e.question, r = e.answerText, h = e.qnaResultId, c = {}, b = {
            item_id: f,
            item_name: q,
            variation_id: l,
            question: o,
            answer_text: r,
            qna_result_id: h
          };
          n && (c.section = n);
          var m = "".concat(y).concat(C(c, this.options)), A = "POST", O = S(b, u(u({}, this.options), {}, {
            requestMethod: A
          }));
          return this.requests.queue(m, A, O, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Send product insights agent answer feedback event
       *
       * @function trackProductInsightsAgentAnswerFeedback
       * @param {object} parameters - Additional parameters to be sent with request
       * @param {string} parameters.itemId - Product id whose page we are on
       * @param {string} parameters.itemName - Product name whose page we are on
       * @param {string} parameters.feedbackLabel - Feedback value: either "thumbs_up" or "thumbs_down"
       * @param {string} [parameters.qnaResultId] - Answer result id returned
       * @param {string} [parameters.variationId] - Variation id whose page we are on
       * @param {string} [parameters.section] - The section name for the item Ex. "Products"
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {(true|Error)}
       * @description A user provided feedback on an answers usefulness
       * @example
       * constructorio.tracker.trackProductInsightsAgentAnswerFeedback({
       *   {
       *     'itemId': '1',
       *     'itemName': 'item1',
       *     'variationId': '2',
       *     'feedbackLabel': 'thumbs_up',
       *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
       *   },
       * );
       */
    }, {
      key: "trackProductInsightsAgentAnswerFeedback",
      value: function(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (e && (0, s.default)(e) === "object" && !Array.isArray(e)) {
          var y = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_feedback?"), n = e.section, f = e.itemId, q = e.itemName, l = e.variationId, o = e.feedbackLabel, r = e.qnaResultId, h = {}, c = {
            item_id: f,
            item_name: q,
            variation_id: l,
            feedback_label: o,
            qna_result_id: r
          };
          n && (h.section = n);
          var b = "".concat(y).concat(C(h, this.options)), m = "POST", A = S(c, u(u({}, this.options), {}, {
            requestMethod: m
          }));
          return this.requests.queue(b, m, A, t), this.requests.send(), !0;
        }
        return this.requests.send(), new Error("parameters is a required parameter of type object");
      }
      /**
       * Subscribe to success or error messages emitted by tracking requests
       *
       * @function on
       * @param {string} messageType - Type of message to listen for ('success' or 'error')
       * @param {function} callback - Callback to be invoked when message received
       * @returns {(true|Error)}
       * @example
       * constructorio.tracker.on('error', (data) => {
       *     // Handle tracking error
       * });
       */
    }, {
      key: "on",
      value: function(e, t) {
        return e !== "success" && e !== "error" ? new Error('messageType must be a string of value "success" or "error"') : !t || typeof t != "function" ? new Error("callback is required and must be a function") : (this.eventemitter.on(e, t), !0);
      }
    }]), R;
  })();
  return x.RequestQueue = k, ht = x, ht;
}
var gt = {}, mr;
function Oi() {
  return mr || (mr = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), i.default = void 0;
    var s = "2.67.4";
    i.default = s;
  })(gt)), gt;
}
var _t = { exports: {} }, pt = { exports: {} }, yt = { exports: {} }, kr;
function Jr() {
  return kr || (kr = 1, (function(i) {
    function s(p, v) {
      (v == null || v > p.length) && (v = p.length);
      for (var _ = 0, d = Array(v); _ < v; _++) d[_] = p[_];
      return d;
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(yt)), yt.exports;
}
var Sr;
function Ti() {
  return Sr || (Sr = 1, (function(i) {
    var s = Jr();
    function p(v) {
      if (Array.isArray(v)) return s(v);
    }
    i.exports = p, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(pt)), pt.exports;
}
var wt = { exports: {} }, qr;
function Ii() {
  return qr || (qr = 1, (function(i) {
    function s(p) {
      if (typeof Symbol < "u" && p[Symbol.iterator] != null || p["@@iterator"] != null) return Array.from(p);
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(wt)), wt.exports;
}
var bt = { exports: {} }, Rr;
function Ui() {
  return Rr || (Rr = 1, (function(i) {
    var s = Jr();
    function p(v, _) {
      if (v) {
        if (typeof v == "string") return s(v, _);
        var d = {}.toString.call(v).slice(8, -1);
        return d === "Object" && v.constructor && (d = v.constructor.name), d === "Map" || d === "Set" ? Array.from(v) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? s(v, _) : void 0;
      }
    }
    i.exports = p, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(bt)), bt.exports;
}
var mt = { exports: {} }, Er;
function Ni() {
  return Er || (Er = 1, (function(i) {
    function s() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(mt)), mt.exports;
}
var xr;
function Di() {
  return xr || (xr = 1, (function(i) {
    var s = Ti(), p = Ii(), v = Ui(), _ = Ni();
    function d(u) {
      return s(u) || p(u) || v(u) || _();
    }
    i.exports = d, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(_t)), _t.exports;
}
var kt, Cr;
function Li() {
  if (Cr) return kt;
  Cr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = i(Di()), _ = i(Ee()), d = Ie(), u = he();
  function g(k, E, S, C) {
    var x = S.apiKey, R = S.clientId, w = S.sessionId, e = S.segments, t = S.userId, y = S.version, n = S.quizzesServiceUrl, f = {
      c: y
    }, q = "";
    if (f.key = x, f.i = R, f.s = w, e && e.length && (f.us = e), t && (f.ui = String(t)), !k || typeof k != "string")
      throw new Error("quizId is a required parameter of type string");
    if (C === "results" && ((0, _.default)(E.answers) !== "object" || !Array.isArray(E.answers) || E.answers.length === 0))
      throw new Error("answers is a required parameter of type array");
    if (E) {
      var l = E.section, o = E.answers, r = E.quizSessionId, h = E.quizVersionId, c = E.page, b = E.resultsPerPage, m = E.filters, A = E.fmtOptions, O = E.hiddenFields;
      l && (f.section = l), h && (f.quiz_version_id = h), r && (f.quiz_session_id = r), o && o.length && (q = "&".concat(u.stringify({
        a: o.map(function(N) {
          return (0, v.default)(N.map(encodeURIComponent)).join(",");
        })
      }))), u.isNil(c) || (f.page = c), u.isNil(b) || (f.num_results_per_page = b), m && (f.filters = m), A && (f.fmt_options = A), O && (f.fmt_options ? f.fmt_options.hidden_fields = O : f.fmt_options = {
        hidden_fields: O
      });
    }
    f._dt = Date.now(), f = u.cleanParams(f);
    var U = u.stringify(f);
    return "".concat(n, "/v1/quizzes/").concat(encodeURIComponent(k), "/").concat(encodeURIComponent(C), "/?").concat(U).concat(q);
  }
  var a = /* @__PURE__ */ (function() {
    function k(E) {
      (0, s.default)(this, k), this.options = E || {}, this.eventDispatcher = new d(E.eventDispatcher);
    }
    return (0, p.default)(k, [{
      key: "getQuizNextQuestion",
      value: function(S, C) {
        var x = this, R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, w, e = this.options.fetch, t = new AbortController(), y = t.signal;
        try {
          w = g(S, C, this.options, "next");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, R, t), e(w, {
          signal: y
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return x.eventDispatcher.queue("quizzes.getQuizNextQuestion.completed", n), n;
          throw new Error("getQuizNextQuestion response data is malformed");
        });
      }
      /**
       * Retrieves filter expression and recommendation URL from given answers
       *
       * @function getQuizResults
       * @description Retrieve quiz recommendation and filter expression from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters to refine result set
       * @param {array} parameters.answers - An array of answers in the format [[1,2], [1], ["true"], ["seen"], [""]]. Based on the question type, answers should either be an integer, "true"/"false", "seen" or an empty string ("") if skipped
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {string} [parameters.quizSessionId] - Session identifier for the quiz. Session ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {number} [parameters.page] - The page number of the results
       * @param {number} [parameters.resultsPerPage] - The number of results per page to return
       * @param {object} [parameters.filters] - Key / value mapping (dictionary) of filters used to refine results
       * @param {object} [parameters.fmtOptions] - Key / value mapping (dictionary) of options used for result formatting
       * @param {string[]} [parameters.hiddenFields] - Hidden metadata fields to return
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @see https://docs.constructor.com/reference/v1-quizzes-get-quiz-results
       * @example
       * constructorio.quizzes.getQuizResults('quizId', {
       *    answers: [[1,2],[1]],
       *    section: '123',
       *    quizVersionId: '123',
       *    quizSessionId: '234'
       * });
       */
    }, {
      key: "getQuizResults",
      value: function(S, C) {
        var x = this, R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, w, e = this.options.fetch, t = new AbortController(), y = t.signal;
        try {
          w = g(S, C, this.options, "results");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, R, t), e(w, {
          signal: y
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return x.eventDispatcher.queue("quizzes.getQuizResults.completed", n), n;
          throw new Error("getQuizResults response data is malformed");
        });
      }
      /**
       * Retrieves configuration for the results page of a particular quiz
       *
       * @function getQuizResultsConfig
       * @description Retrieve quiz results page configuration from Constructor.io API
       * @param {string} quizId - The identifier of the quiz
       * @param {string} parameters - Additional parameters
       * @param {string} [parameters.section] - Product catalog section
       * @param {string} [parameters.quizVersionId] - Version identifier for the quiz. Version ID will be returned with the first request and it should be passed with subsequent requests. More information can be found: https://docs.constructor.com/reference/configuration-quizzes
       * @param {object} [networkParameters] - Parameters relevant to the network request
       * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
       * @returns {Promise}
       * @example
       * constructorio.quizzes.getQuizResultsConfig('quizId', {
       *    quizVersionId: '123',
       * });
       */
    }, {
      key: "getQuizResultsConfig",
      value: function(S, C) {
        var x = this, R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, w, e = this.options.fetch, t = new AbortController(), y = t.signal;
        try {
          w = g(S, C, this.options, "results_config");
        } catch (n) {
          return Promise.reject(n);
        }
        return u.applyNetworkTimeout(this.options, R, t), e(w, {
          signal: y
        }).then(u.convertResponseToJson).then(function(n) {
          if (n.quiz_version_id)
            return x.eventDispatcher.queue("quizzes.getQuizResultsConfig.completed", n), n;
          throw new Error("getQuizResultsConfig response data is malformed");
        });
      }
    }]), k;
  })();
  return kt = a, kt;
}
var Ne = { exports: {} }, Ar;
function Ft() {
  if (Ar) return Ne.exports;
  Ar = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = i(Ve()), _ = he(), d = _.cleanParams, u = _.trimNonBreakingSpaces, g = _.encodeURIComponentRFC3986, a = _.stringify;
  function k(C, x, R) {
    var w = R.apiKey, e = R.version, t = R.sessionId, y = R.clientId, n = R.userId, f = R.segments, q = R.testCells, l = R.agentServiceUrl, o = R.assistantServiceUrl, r = {
      c: e
    };
    r.key = w, r.i = y, r.s = t;
    var h = l || o;
    if (!C || typeof C != "string")
      throw new Error("intent is a required parameter of type string");
    if (!x.domain || typeof x.domain != "string")
      throw new Error("parameters.domain is a required parameter of type string");
    if (q && Object.keys(q).forEach(function(O) {
      r["ef-".concat(O)] = q[O];
    }), f && f.length && (r.us = f), n && (r.ui = String(n)), x) {
      var c = x.domain, b = x.numResultsPerPage;
      c && (r.domain = c), b && (r.num_results_per_page = b);
    }
    r._dt = Date.now(), r = d(r);
    var m = a(r), A = C.replace(/^\//, "|");
    return "".concat(h, "/v1/intent/").concat(g(u(A)), "?").concat(m);
  }
  function E(C, x, R) {
    var w = function(t) {
      C.addEventListener(t, function(y) {
        var n = JSON.parse(y.data);
        x.enqueue({
          type: t,
          data: n
        });
      });
    };
    Object.values(R).forEach(function(e) {
      e !== R.END && w(e);
    }), C.addEventListener(R.END, function() {
      x.close(), C.close();
    }), C.onerror = function(e) {
      x.error(e), C.close();
    };
  }
  var S = /* @__PURE__ */ (function() {
    function C(x) {
      (0, s.default)(this, C), this.options = x || {};
    }
    return (0, p.default)(C, [{
      key: "getAgentResultsStream",
      value: (
        /**
         * Retrieve agent results from EventStream
         *
         * @function getAgentResultsStream
         * @description Retrieve a stream of agent results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} [parameters] - Additional parameters to refine result set
         * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
         * @param {number} [parameters.numResultsPerPage] - The total number of results to return
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.agent.getAgentResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(R, w) {
          var e, t;
          try {
            var y = k(R, w, this.options);
            e = new EventSource(y), t = new ReadableStream({
              // To be called on stream start
              start: function(l) {
                E(e, l, C.EventTypes);
              },
              // To be called on stream cancelling
              cancel: function() {
                e.close();
              }
            });
          } catch (q) {
            if (t) {
              var n;
              (n = t) === null || n === void 0 || n.cancel();
            } else {
              var f;
              (f = e) === null || f === void 0 || f.close();
            }
            throw new Error(q.message);
          }
          return t;
        }
      )
    }]), C;
  })();
  return (0, v.default)(S, "EventTypes", {
    START: "start",
    // Denotes the start of the stream
    GROUP: "group",
    // Represents a semantic grouping of search results, optionally having textual explanation
    SEARCH_RESULT: "search_result",
    // Represents a set of results with metadata (used to show results with search refinements)
    ARTICLE_REFERENCE: "article_reference",
    // Represents a set of content with metadata
    RECIPE_INFO: "recipe_info",
    // Represents recipes' auxiliary information like cooking times & serving sizes
    RECIPE_INSTRUCTIONS: "recipe_instructions",
    // Represents recipe instructions
    SERVER_ERROR: "server_error",
    // Server Error event
    IMAGE_META: "image_meta",
    // This event type is used for enhancing recommendations with media content such as images
    END: "end"
    // Represents the end of data stream
  }), Ne.exports = S, Ne.exports.createAgentUrl = k, Ne.exports.setupEventListeners = E, Ne.exports;
}
var De = { exports: {} }, St = { exports: {} }, Or;
function Gr() {
  return Or || (Or = 1, (function(i) {
    function s(p) {
      if (p === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return p;
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(St)), St.exports;
}
var qt = { exports: {} }, Rt = { exports: {} }, Tr;
function ji() {
  return Tr || (Tr = 1, (function(i) {
    function s(p, v) {
      return i.exports = s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, d) {
        return _.__proto__ = d, _;
      }, i.exports.__esModule = !0, i.exports.default = i.exports, s(p, v);
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Rt)), Rt.exports;
}
var Ir;
function Pi() {
  return Ir || (Ir = 1, (function(i) {
    var s = ji();
    function p(v, _) {
      if (typeof _ != "function" && _ !== null) throw new TypeError("Super expression must either be null or a function");
      v.prototype = Object.create(_ && _.prototype, {
        constructor: {
          value: v,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(v, "prototype", {
        writable: !1
      }), _ && s(v, _);
    }
    i.exports = p, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(qt)), qt.exports;
}
var Et = { exports: {} }, Ur;
function Bi() {
  return Ur || (Ur = 1, (function(i) {
    var s = Ee().default, p = Gr();
    function v(_, d) {
      if (d && (s(d) == "object" || typeof d == "function")) return d;
      if (d !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return p(_);
    }
    i.exports = v, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(Et)), Et.exports;
}
var xt = { exports: {} }, Nr;
function Fi() {
  return Nr || (Nr = 1, (function(i) {
    function s(p) {
      return i.exports = s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(v) {
        return v.__proto__ || Object.getPrototypeOf(v);
      }, i.exports.__esModule = !0, i.exports.default = i.exports, s(p);
    }
    i.exports = s, i.exports.__esModule = !0, i.exports.default = i.exports;
  })(xt)), xt.exports;
}
var Dr;
function Mi() {
  if (Dr) return De.exports;
  Dr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = i(Gr()), _ = i(Pi()), d = i(Bi()), u = i(Fi()), g = i(Ve());
  function a(w) {
    var e = k();
    return function() {
      var t, y = (0, u.default)(w);
      if (e) {
        var n = (0, u.default)(this).constructor;
        t = Reflect.construct(y, arguments, n);
      } else t = y.apply(this, arguments);
      return (0, d.default)(this, t);
    };
  }
  function k() {
    try {
      var w = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (k = function() {
      return !!w;
    })();
  }
  var E = Ft(), S = Ft(), C = S.createAgentUrl, x = S.setupEventListeners, R = /* @__PURE__ */ (function(w) {
    (0, _.default)(t, w);
    var e = a(t);
    function t() {
      var y;
      (0, s.default)(this, t);
      for (var n = arguments.length, f = new Array(n), q = 0; q < n; q++)
        f[q] = arguments[q];
      return y = e.call.apply(e, [this].concat(f)), (0, g.default)((0, v.default)(y), "EventTypes", E.EventTypes), y;
    }
    return (0, p.default)(t, [{
      key: "getAssistantResultsStream",
      value: (
        /**
         * Retrieve assistant results from EventStream
         *
         * @deprecated Use getAssistantResultsStream from the Agent module instead.
         * @function getAssistantResultsStream
         * @description Retrieve a stream of assistant results from Constructor.io API
         * @param {string} intent - Intent to use to perform an intent based recommendations
         * @param {object} [parameters] - Additional parameters to refine result set
         * @param {string} [parameters.domain] - domain name e.g. swimming sports gear, groceries
         * @param {number} [parameters.numResultsPerPage] - The total number of results to return
         * @returns {ReadableStream} Returns a ReadableStream.
         * @example
         * const readableStream = constructorio.assistant.getAssistantResultsStream('I want to get shoes', {
         *     domain: "nike_sportswear",
         * });
         * const reader = readableStream.getReader();
         * const { value, done } = await reader.read();
         */
        function(n, f) {
          return this.getAgentResultsStream(n, f);
        }
      )
    }]), t;
  })(E);
  return De.exports = R, De.exports.createAssistantUrl = C, De.exports.setupEventListeners = x, De.exports;
}
var Ct, Lr;
function zi() {
  if (Lr) return Ct;
  Lr = 1;
  var i = fe(), s = i(ge()), p = i(_e()), v = wi(), _ = mi(), d = ki(), u = Si(), g = qi(), a = Ai(), k = Ie(), E = he(), S = Oi(), C = S.default, x = Li(), R = Ft(), w = Mi(), e = function() {
    var n = "ciojs-client-", f = [];
    return E.canUseDOM() || f.push("domless"), typeof process < "u" && typeof process.env < "u" && process.env.BUNDLED && f.push("bundled"), "".concat(n).concat(f.join("-")).concat(f.length ? "-" : "").concat(C);
  }, t = /* @__PURE__ */ (function() {
    function y() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      (0, s.default)(this, y);
      var f = n.apiKey, q = n.version, l = n.serviceUrl, o = n.quizzesServiceUrl, r = n.agentServiceUrl, h = n.assistantServiceUrl, c = n.segments, b = n.testCells, m = n.clientId, A = n.sessionId, O = n.userId, U = n.fetch, N = n.trackingSendDelay, I = n.sendReferrerWithTrackingEvents, L = n.sendTrackingEvents, j = n.eventDispatcher, D = n.idOptions, P = n.beaconMode, F = n.networkParameters;
      if (!f || typeof f != "string")
        throw new Error("API key is a required parameter of type string");
      var M, K, Q = typeof Gt < "u" && Gt.CLIENT_VERSION;
      if (E.canUseDOM()) {
        var B = new v(D || {});
        M = B.session_id, K = B.client_id;
      } else {
        if (!A || typeof A != "number")
          throw new Error("sessionId is a required user parameter of type number");
        if (!m || typeof m != "string")
          throw new Error("clientId is a required user parameter of type string");
      }
      var G = l && l.replace(/\/$/, "");
      this.options = {
        apiKey: f,
        version: q || Q || e(),
        serviceUrl: E.addHTTPSToString(G) || "https://ac.cnstrc.com",
        quizzesServiceUrl: o && o.replace(/\/$/, "") || "https://quizzes.cnstrc.com",
        agentServiceUrl: r && r.replace(/\/$/, "") || "https://agent.cnstrc.com",
        assistantServiceUrl: h && h.replace(/\/$/, "") || "https://assistant.cnstrc.com",
        sessionId: A || M,
        clientId: m || K,
        userId: O,
        segments: c,
        testCells: b,
        fetch: U || fetch,
        trackingSendDelay: N,
        sendTrackingEvents: L,
        sendReferrerWithTrackingEvents: I,
        eventDispatcher: j,
        beaconMode: P !== !1,
        // Defaults to 'true',
        networkParameters: F || {}
      }, this.search = new _(this.options), this.browse = new d(this.options), this.autocomplete = new u(this.options), this.recommendations = new g(this.options), this.tracker = new a(this.options), this.quizzes = new x(this.options), this.agent = new R(this.options), this.assistant = new w(this.options), new k(n.eventDispatcher).queue("instantiated", this.options);
    }
    return (0, p.default)(y, [{
      key: "setClientOptions",
      value: function(f) {
        if (Object.keys(f).length) {
          var q = f.apiKey, l = f.segments, o = f.testCells, r = f.sessionId, h = f.userId;
          q && (this.options.apiKey = q), l && (this.options.segments = l), o && (this.options.testCells = o), r && !E.canUseDOM() && (this.options.sessionId = r), "userId" in f && (this.options.userId = h);
        }
      }
    }]), y;
  })();
  return t.Tracker = a, E.canUseDOM() && (window.ConstructorioClient = t), Ct = t, Ct;
}
var Qi = zi();
const Ki = /* @__PURE__ */ Xr(Qi), Vi = "1.4.2", Je = (i) => {
  if (!i.apiKey)
    throw new Error("ConstructorIO Api key is required");
  return new Ki({
    sendTrackingEvents: !0,
    version: `cio-ui-plp-${Vi}`,
    ...i
  });
}, nn = (i, s, p) => {
  const v = se.useMemo(() => Je(i), [i]);
  return Kt({
    queryKey: ["cioRecommendations", s, p],
    placeholderData: zt,
    queryFn: () => v.recommendations.getRecommendations(s, {
      numResults: 8,
      ...p
    }),
    enabled: !!v && !!s
  });
}, on = (i, s, p) => {
  const v = se.useMemo(() => Je(i), [i]);
  return Kt({
    queryKey: ["cioBrowse", s, p],
    placeholderData: zt,
    queryFn: () => {
      if ("filterName" in s && s.filterName && s.filterValue)
        return v.browse.getBrowseResults(s.filterName, s.filterValue, p);
      if ("itemIds" in s && s.itemIds)
        return v.browse.getBrowseResultsForItemIds(s.itemIds, p);
    },
    enabled: !!v
  });
}, sn = (i, s) => {
  const p = se.useMemo(() => Je(i), [i]);
  return Kt({
    queryKey: ["cioSearch", s],
    placeholderData: zt,
    queryFn: () => {
      const {
        query: v,
        ..._
      } = s;
      return p.search.getSearchResults(v, _);
    },
    enabled: !!p && !!s.query
  });
};
const Ji = [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
], Gi = Mr("star-half", Ji);
const Hi = [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
], jr = Mr("star", Hi);
function Pr({
  children: i,
  className: s,
  variant: p,
  size: v,
  onRemove: _
}) {
  const d = _ ? "button" : "span";
  return /* @__PURE__ */ X.jsxs(d, {
    className: Wr("badge items-center gap-2", p === "destructive" ? "badge-destructive" : p === "warn" ? "badge-warn" : "badge-default", s, `badge-${v || "md"}`, _ && "with-remove"),
    onClick: _,
    children: [i, _ && /* @__PURE__ */ X.jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      className: "icon icon-close-small",
      viewBox: "0 0 12 13",
      children: /* @__PURE__ */ X.jsx("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
      })
    })]
  });
}
const Br = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), Mt = (i, s, p) => {
  if (!i)
    return i || "";
  const _ = new URL(i.includes("http") ? i : `https://${i}`).pathname.split(".").pop();
  return _ ? i.replace(`.${_}`, `_${s}x${p || ""}.${_}`) : i;
};
function Wi({
  src: i,
  className: s,
  alt: p,
  width: v,
  height: _,
  aspectRatio: d,
  loading: u = "lazy",
  srcSet: g,
  widths: a = [180, 480, 900, 1400, 1800, 2400, 3600, 4734]
}) {
  return /* @__PURE__ */ X.jsx("img", {
    src: i,
    alt: p,
    srcSet: g || a?.map((k) => {
      let E = i, S = 180;
      return typeof k == "number" ? (S = k, E = Mt(i, k, d ? d * k : k)) : (S = k[0], E = Mt(i, k[0], k[1])), `${E} ${S}w`;
    })?.join(", "),
    width: v,
    height: _,
    loading: u,
    sizes: "(min-width: 1400px) calc(100vw / 3), (min-width: 750px) calc(100vw / 3), (min-width: 480px) calc(100vw / 2), calc(100vw / 2)",
    className: s
  });
}
const Xi = (i) => {
  const s = {
    "data-cnstrc-item-id": i.id,
    "data-cnstrc-item-name": i.name
  };
  return i.price && (s["data-cnstrc-item-price"] = i.price.toString()), i.variation_id && (s["data-cnstrc-item-variation-id"] = i.variation_id), s;
};
function an({
  data: i,
  onClick: s,
  showMfg: p,
  showRating: v,
  css: _ = {},
  imageCount: d = 2,
  saleBadgePosition: u = "above-price"
}) {
  const {
    id: g,
    name: a = "",
    price: k,
    url: E,
    images: S = [],
    on_sale: C,
    compareAtPrice: x,
    manufacturer: R,
    rating: w = 0,
    rating_count: e = 0,
    is_sponsored: t = !1
  } = i;
  let y = C ?? !1;
  const n = Number(x) ?? 0, f = Math.round(w * 2) / 2;
  y && n > 0 && k && k > 0 && n <= k && (y = !1);
  const q = a.replace(/\\/g, ""), l = Xi(i);
  return /* @__PURE__ */ X.jsxs("div", {
    className: _.root,
    ...l,
    children: [/* @__PURE__ */ X.jsx("a", {
      className: ze("flex justify-center items-center group relative", _.imageWrapper),
      href: E,
      onClick: (o) => s?.(o, i),
      children: S.slice(0, d).map((o, r) => /* @__PURE__ */ X.jsx(Wi, {
        src: o,
        alt: q,
        width: 360,
        height: 360,
        className: ze("w-full h-full object-contain", S.length > 1 ? r === 0 ? "group-hover:hidden" : "hidden group-hover:block" : void 0),
        srcSet: [[360, 480], [720, 900]].map(([h, c]) => `${Mt(o, h, h)} ${c}w`).join(", ")
      }))
    }), /* @__PURE__ */ X.jsxs("div", {
      className: ze("flex flex-col gap-1.5 mt-1.5", _.contentWrapper),
      children: [/* @__PURE__ */ X.jsxs("div", {
        children: [/* @__PURE__ */ X.jsx("a", {
          className: "hover:underline leading- line-clamp-3 text-black max-h-[4.5rem]",
          href: E,
          onClick: (o) => s?.(o, i),
          children: q
        }), p && R && /* @__PURE__ */ X.jsxs("span", {
          className: "text-mutedAlt font-light text-sm",
          children: ["by ", R]
        })]
      }), v === "yotpo" ? /* @__PURE__ */ X.jsx("div", {
        className: "yotpo-widget-instance h-9",
        "data-yotpo-instance-id": "1194434",
        "data-yotpo-product-id": g,
        "data-yotpo-section-id": "index"
      }) : v === "metafield" && w > 0 && /* @__PURE__ */ X.jsxs("div", {
        className: "flex items-end gap-1",
        children: [Array.from({
          length: Math.floor(f)
        }).map((o, r) => /* @__PURE__ */ X.jsx(jr, {
          className: "size-5 stroke-0 fill-yellow-400"
        }, r)), f % 1 !== 0 && /* @__PURE__ */ X.jsx(Gi, {
          className: "size-5 stroke-0 fill-yellow-400"
        }), Array.from({
          length: (f % 1 !== 0 ? 4 : 5) - Math.floor(f)
        }).map((o, r) => /* @__PURE__ */ X.jsx(jr, {
          className: "size-5 stroke-1 text-yellow-400"
        }, r)), e && /* @__PURE__ */ X.jsxs("span", {
          className: "text-sm leading-none",
          children: ["(", /* @__PURE__ */ X.jsx("u", {
            children: e
          }), ")"]
        })]
      }), /* @__PURE__ */ X.jsxs("div", {
        className: ze("flex gap-2", u === "right-of-price" ? "h-6 items-center" : "flex-col items-start"),
        children: [u === "above-price" && /* @__PURE__ */ X.jsx(Pr, {
          variant: "destructive",
          size: "xs",
          children: "SALE"
        }), /* @__PURE__ */ X.jsxs("div", {
          className: "flex gap-1 items-end",
          children: [k && k > 0 && /* @__PURE__ */ X.jsx("span", {
            className: "font-bold leading-none",
            children: Br.format(k).replace(".00", "")
          }), y && k && n > 0 && n > k && /* @__PURE__ */ X.jsx("s", {
            className: "text-sm leading-none text-mutedAlt",
            children: Br.format(n).replace(".00", "")
          })]
        }), y && u === "right-of-price" && /* @__PURE__ */ X.jsx(Pr, {
          variant: "destructive",
          size: "xs",
          children: "SALE"
        })]
      }), k && k >= 49 && /* @__PURE__ */ X.jsx("p", {
        className: "free-shipping text-sm",
        children: "Free Shipping"
      }), t && /* @__PURE__ */ X.jsx("div", {
        className: "text-sm text-mutedAlt",
        children: "Sponsored"
      })]
    })]
  });
}
function un(i) {
  const s = se.useMemo(() => Je(i), [i]), p = se.useCallback((d, u, g) => {
    const {
      name: a,
      id: k,
      variation_id: E
    } = d;
    s.tracker.trackRecommendationClick({
      variationId: E,
      resultId: g.result_id,
      resultCount: g.response?.total_num_results || 0,
      resultPositionOnPage: u + 1,
      podId: g.pod_id,
      strategyId: "complimentary",
      itemId: k,
      itemName: a
    });
  }, [s]), v = se.useCallback((d, u, g) => {
    const {
      name: a,
      id: k,
      variation_id: E
    } = d;
    s.tracker.trackSearchResultClick(g.query, {
      itemId: k,
      itemName: a,
      variationId: E,
      section: u.section,
      resultId: g.result_id
    });
  }, [s]), _ = se.useCallback((d, u, g, a) => {
    if (!a.filterName && !a.filterValue)
      return;
    const {
      id: k,
      variation_id: E
    } = d;
    s.tracker.trackBrowseResultClick({
      variationId: E,
      resultId: a.result_id,
      resultCount: a.response?.total_num_results || 0,
      resultPage: g.page,
      resultPositionOnPage: u + 1,
      numResultsPerPage: g.resultsPerPage,
      selectedFilters: g.filters,
      filterName: a.filterName,
      filterValue: a.filterValue,
      itemId: k
    });
  }, [s]);
  return se.useEffect(() => {
    s && window.__cioSessionStarted !== !0 && (window.__cioSessionStarted = s.tracker.trackSessionStart());
  }, [s]), {
    handleRecommendationsClick: p,
    handleSearchClick: v,
    handleBrowseClick: _
  };
}
export {
  Pr as B,
  Br as C,
  an as P,
  un as a,
  on as b,
  Kt as c,
  nn as d,
  sn as u
};
